export const lightMusic =
  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/apps%2Fmobile%2FHeadphone.gif?alt=media&token=b6fdfa08-28c5-4b74-8610-2a57ea399014";
export const darkMusic =
  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/apps%2Fmobile%2FHeadphone%20(2).gif?alt=media&token=41083e19-fe09-4eef-a1fa-c2c2342cd445";

export const Podcast_api =
  "https://itunes.apple.com/search?term=${searchText}&media=podcast";

export const mySpaceData = [
  {
    id: 1,
    type: 1, // 0 - Event, 1 - Course, 2 - Consultation, 3 - Project
    name: "Innovation Management: Strategy and Execution",
    image_url:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Finnovation-management-strategy-and-execution.jpg?alt=media&token=9ef98967-c7bd-4f67-8d64-048225b069a5",
    start_date: "3 October 2021",
    slug: "innovation-management-strategy-and-execution/dashboard",
  },
  {
    id: 2,
    type: 0, // 0 - Event, 1 - Course, 2 - Consultation, 3 - Project
    name: "Blue Ocean Awards: 7th Edition",
    image_url: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/BOA.png",
    start_date: "14 August 2021",
    slug: "blueoceanawards/dashboard",
  },
  {
    id: 4,
    type: 3, // 0 - Event, 1 - Course, 2 - Consultation, 3 - Project
    name: "Eat Fit: Healthy Food Project",
    image_url: `https://png.pngtree.com/thumb_back/fw800/back_our/20190620/ourmid/pngtree-blue-chalkboard-simple-food-cover-rice-cooker-e-commerce-banner-image_172736.jpg`,
    slug: "eat-fit/dashboard",
  },
  {
    id: 5,
    type: 3, // 0 - Event, 1 - Course, 2 - Consultation, 3 - Project
    name: "Project C",
    image_url: `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQWy_pInbN7RQIrtmO-BN8pHw9cHvS1zdoCem81tsei8w8VlsPCEDLaWQ6pSSnWs2cIXPM&usqp=CAU`,
    slug: "project-C/dashboard",
  },
  {
    id: 3,
    type: 2, // 0 - Event, 1 - Course, 2 - Consultation, 3 - Project
    name: "Igesia Clinic",
    image_url: `${process.env.PUBLIC_URL + "/assets/dr-reena.jpeg"}`,
    start_date: "3 October 2021",
    slug: "igesia-clinic/dashboard",
  },
];

export const eventList = [
  {
    id: "1",
    name: "Blue Ocean Awards: 7th Edition",
    slug: "blueoceanawards",
    description:
      "7th edition turns international in 2021 on the 11th of May, simultaneously at HEC Paris, Bordeaux Technowest, Sciences-U EFAB in Lyon and the French Embassy of South Africa in Pretoria",
    image:
      "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/apps%2Fmobile%2FBOA.png?alt=media&token=6515c6d4-4aa3-4ec5-b527-e1ed29cff9a3",
    date: "11 May, 2021",
    isEvent: true,
    speakers: [
      {
        name: "Aurélien LECHEVALLIER",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766317311-1619627501261-aurelien-lechevallier.jpg?alt=media&token=b8d27012-f1b4-4cca-894a-04ecb7cf3e7f",
        designation: "French Ambassador in South Africa",
        id: "1",
        username: "LECHEVALLIER",
      },
      {
        name: "Emmanuel SUQUET",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FOqNlEUPMfjR345w0KDnhLfHrHpp1%2F1620425452206-1620425029396-Emmanuel%20SUQUET.jpg?alt=media&token=2591421c-439e-45f8-b05d-66c1a1f6d8be",
        designation: "Deputy Head of Mission",
        id: "2",
        username: "emmanuel",
      },
      {
        name: "Stanley STEENKAMP",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766526125-1619627501339-stanley-steenkamp.jpg?alt=media&token=47f1b285-1c95-4be8-8712-a7d23d0cb188",
        designation: "CEO, Veolia Services Southern Africa",
        id: "3",
        username: "stanley",
      },
      {
        name: "Khadija AMRANI",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619768031983-1619627501310-khadija-amrani.jpg?alt=media&token=e92e660b-7b5a-4382-94f1-e929911b88f4",
        designation: "Marketing Director",
        id: "4",
        username: "emmanuel",
      },
    ],
    agendaList: [
      {
        date: "May 11th 11:00 - 11:15",
        place: "Paris",
        title: "WELCOME & AGENDA OF THE DAY [FR & ENG]",
        description:
          "Hosted by A. Eral, F. Besson, A. Castillon, J. Hunter, P. Hoeblich, S. Alix",
      },
      {
        date: "May 11th  11:30 - 12:30",
        place: "Paris",
        title: "BLUE OCEAN HACKATHON FINAL BY HEC PARIS [FR & ENG]",
        description:
          "With HEC students & Alumni. Hosted by S. Madoeuf – HEC Paris",
      },
      {
        date: "May 11th 13:00 - 14:15",
        place: "Paris",
        title: "BLUE OCEAN LEADERSHIP BY SERVIER MOROCCO [FR]",
        description:
          "With G. Recorbet – General Manager Servier Morocco, A. Dakki – Human Resources Manager Servier Morocco, Khadija Amrani – Marketing Director Servier Morocco, Nour Alamy – Pharmaceutical Affairs Director Servier Morocco Hosted by A. Eral",
      },
      {
        date: "May 11th 15:00 - 16:15",
        place: "Paris",
        title: "BLUE OCEAN STRATEGY BY MARVEL STUDIOS [ENG] ",
        description:
          "With D. Maisel (founding CEO – Marvel Studios), J. Hunter (Senior Blue Ocean Strategy Practitioner) Hosted by M. Olenick (Institute Executive Fellow – INSEAD Blue Ocean Strategy Institute)",
      },
    ],
    boothList: [
      {
        id: "1",
        title: "Organizers & Major Sponsors",
        booths: [
          {
            id: "11",
            title: "Blue Ocean Awards",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FKQ1gHZ9qhdSrfJFqK4sWa5pfFK13%2F1620707889044-1620707650000-boa-logo.jpg?alt=media&token=40772d41-84cf-4f43-8822-154f059b69f2",
          },
          {
            id: "22",
            title: "HEC Paris",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FKQ1gHZ9qhdSrfJFqK4sWa5pfFK13%2F1620708186869-1620708168000-hec.jpg?alt=media&token=522946e2-01ac-4603-9b2c-970f71e45eb4",
          },
          {
            id: "33",
            title: "MICHELIN",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FXwfiVoqPFPfFaOpT1A6Y6grSUmz1%2F1620124422389-1619840753960-Michelin_G_S_Fr_WhiteBG_RGB_0618-01.png?alt=media&token=647e64e4-08b8-4b27-b654-6c1b2de273ab",
          },
        ],
      },
      {
        id: "2",
        title: "Sponsors",
        booths: [
          {
            id: "11",
            title: "France Batter",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FKQ1gHZ9qhdSrfJFqK4sWa5pfFK13%2F1620707997278-1620707781000-france-barter.jpg?alt=media&token=091fff75-5b73-4251-8f9f-be3ee9e1b98c",
          },
          {
            id: "22",
            title: "HUB 612",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1620318148654-1620318124365-WhatsApp%20Image%202021-05-06%20at%209.52.00%20PM.jpeg?alt=media&token=5626bdc0-4abc-454c-aa4e-c35121714478",
          },
        ],
      },
      {
        id: "3",
        title: "Partners",
        booths: [
          {
            id: "11",
            title: "Forbes",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1620318729695-1620318714469-WhatsApp%20Image%202021-05-06%20at%2010.01.50%20PM.jpeg?alt=media&token=5e423ed2-7b07-44bb-8e83-fa24e6992ac5",
          },
          {
            id: "22",
            title: `Pink Innov'`,
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy0Su0xVve2QuEwe7GED3OyKCf8a2%2F1619454679697-1476537658000-logo-pink-innov-texte-jpg.jpg?alt=media&token=94cbcc69-7457-43d0-9de1-22f47c967775",
          },
          {
            id: "33",
            title: "EngageX",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2F0dl4HxLhbtUpWbeSlmGxtJI1PCo2%2F1620380265812-1620380246744-engagex%20(1).png?alt=media&token=fcb160ff-64a6-4dd0-a948-2209e53c7ad0",
          },
        ],
      },
    ],
  },
  {
    id: "2",
    name: "Prologue 2020",
    slug: "prologue-2020",
    description:
      "PROLOGUE is an orientation program for I MDS students. Prologue-2020 is the 12th in the series hosted every year since 2009. This program will have lecturers from eminent speakers.",
    image: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/Prologue-2020.jpg",
    date: "3 September, 2021",
    isEvent: true,
    speakers: [
      {
        name: "Aurélien LECHEVALLIER",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766317311-1619627501261-aurelien-lechevallier.jpg?alt=media&token=b8d27012-f1b4-4cca-894a-04ecb7cf3e7f",
        designation: "French Ambassador in South Africa",
        id: "1",
        username: "LECHEVALLIER",
      },
      {
        name: "Emmanuel SUQUET",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FOqNlEUPMfjR345w0KDnhLfHrHpp1%2F1620425452206-1620425029396-Emmanuel%20SUQUET.jpg?alt=media&token=2591421c-439e-45f8-b05d-66c1a1f6d8be",
        designation: "Deputy Head of Mission",
        id: "2",
        username: "emmanuel",
      },
      {
        name: "Stanley STEENKAMP",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766526125-1619627501339-stanley-steenkamp.jpg?alt=media&token=47f1b285-1c95-4be8-8712-a7d23d0cb188",
        designation: "CEO, Veolia Services Southern Africa",
        id: "3",
        username: "stanley",
      },
      {
        name: "Khadija AMRANI",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619768031983-1619627501310-khadija-amrani.jpg?alt=media&token=e92e660b-7b5a-4382-94f1-e929911b88f4",
        designation: "Marketing Director",
        id: "4",
        username: "emmanuel",
      },
    ],
  },
  {
    id: "3",
    name: "Cidades Mais Humanas, Inteligentes e Sustenaiveis",
    slug: "cidades-mais-humanas-inteligentes-e-sustenaiveis",
    description:
      "O LDRS e a Frente Nacional de Prefeitos (FNP) apresentam Painel Online com Lideranças Municipais eleitas em 2020",
    image: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/ldrs-2.jpg",
    date: "3 October, 2021",
    isEvent: true,
    speakers: [
      {
        name: "Aurélien LECHEVALLIER",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766317311-1619627501261-aurelien-lechevallier.jpg?alt=media&token=b8d27012-f1b4-4cca-894a-04ecb7cf3e7f",
        designation: "French Ambassador in South Africa",
        id: "1",
        username: "LECHEVALLIER",
      },
      {
        name: "Emmanuel SUQUET",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FOqNlEUPMfjR345w0KDnhLfHrHpp1%2F1620425452206-1620425029396-Emmanuel%20SUQUET.jpg?alt=media&token=2591421c-439e-45f8-b05d-66c1a1f6d8be",
        designation: "Deputy Head of Mission",
        id: "2",
        username: "emmanuel",
      },
      {
        name: "Stanley STEENKAMP",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766526125-1619627501339-stanley-steenkamp.jpg?alt=media&token=47f1b285-1c95-4be8-8712-a7d23d0cb188",
        designation: "CEO, Veolia Services Southern Africa",
        id: "3",
        username: "stanley",
      },
      {
        name: "Khadija AMRANI",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619768031983-1619627501310-khadija-amrani.jpg?alt=media&token=e92e660b-7b5a-4382-94f1-e929911b88f4",
        designation: "Marketing Director",
        id: "4",
        username: "emmanuel",
      },
    ],
  },
  {
    id: "4",
    name: "Indian Orthodontic Society Presidential Calendar Events 2021",
    slug: "indian-orthodontic-society-presidential-calendar-events-2021",
    description:
      "Role of the dentist in the management of Upper airway Sleep disorders.",
    image: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/ios-smile.jpg",
    date: "3 November, 2021",
    isEvent: true,
    speakers: [
      {
        name: "Aurélien LECHEVALLIER",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766317311-1619627501261-aurelien-lechevallier.jpg?alt=media&token=b8d27012-f1b4-4cca-894a-04ecb7cf3e7f",
        designation: "French Ambassador in South Africa",
        id: "1",
        username: "LECHEVALLIER",
      },
      {
        name: "Emmanuel SUQUET",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FOqNlEUPMfjR345w0KDnhLfHrHpp1%2F1620425452206-1620425029396-Emmanuel%20SUQUET.jpg?alt=media&token=2591421c-439e-45f8-b05d-66c1a1f6d8be",
        designation: "Deputy Head of Mission",
        id: "2",
        username: "emmanuel",
      },
      {
        name: "Stanley STEENKAMP",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766526125-1619627501339-stanley-steenkamp.jpg?alt=media&token=47f1b285-1c95-4be8-8712-a7d23d0cb188",
        designation: "CEO, Veolia Services Southern Africa",
        id: "3",
        username: "stanley",
      },
      {
        name: "Khadija AMRANI",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619768031983-1619627501310-khadija-amrani.jpg?alt=media&token=e92e660b-7b5a-4382-94f1-e929911b88f4",
        designation: "Marketing Director",
        id: "4",
        username: "emmanuel",
      },
    ],
  },
];

export const myEventList = [
  {
    id: "1",
    name: "Blue Ocean Awards: 7th Edition",
    description:
      "7th edition turns international in 2021 on the 11th of May, simultaneously at HEC Paris, Bordeaux Technowest, Sciences-U EFAB in Lyon and the French Embassy of South Africa in Pretoria",
    image:
      "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/apps%2Fmobile%2FBOA.png?alt=media&token=6515c6d4-4aa3-4ec5-b527-e1ed29cff9a3",
    date: "11 May, 2021",
    isEvent: true,
    speakers: [
      {
        name: "Aurélien LECHEVALLIER",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766317311-1619627501261-aurelien-lechevallier.jpg?alt=media&token=b8d27012-f1b4-4cca-894a-04ecb7cf3e7f",
        designation: "French Ambassador in South Africa",
        id: "1",
        username: "LECHEVALLIER",
      },
      {
        name: "Emmanuel SUQUET",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FOqNlEUPMfjR345w0KDnhLfHrHpp1%2F1620425452206-1620425029396-Emmanuel%20SUQUET.jpg?alt=media&token=2591421c-439e-45f8-b05d-66c1a1f6d8be",
        designation: "Deputy Head of Mission",
        id: "2",
        username: "emmanuel",
      },
      {
        name: "Stanley STEENKAMP",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619766526125-1619627501339-stanley-steenkamp.jpg?alt=media&token=47f1b285-1c95-4be8-8712-a7d23d0cb188",
        designation: "CEO, Veolia Services Southern Africa",
        id: "3",
        username: "stanley",
      },
      {
        name: "Khadija AMRANI",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1619768031983-1619627501310-khadija-amrani.jpg?alt=media&token=e92e660b-7b5a-4382-94f1-e929911b88f4",
        designation: "Marketing Director",
        id: "4",
        username: "emmanuel",
      },
    ],
    agendaList: [
      {
        date: "May 11th 11:00 - 11:15",
        place: "Paris",
        title: "WELCOME & AGENDA OF THE DAY [FR & ENG]",
        description:
          "Hosted by A. Eral, F. Besson, A. Castillon, J. Hunter, P. Hoeblich, S. Alix",
      },
      {
        date: "May 11th  11:30 - 12:30",
        place: "Paris",
        title: "BLUE OCEAN HACKATHON FINAL BY HEC PARIS [FR & ENG]",
        description:
          "With HEC students & Alumni. Hosted by S. Madoeuf – HEC Paris",
      },
      {
        date: "May 11th 13:00 - 14:15",
        place: "Paris",
        title: "BLUE OCEAN LEADERSHIP BY SERVIER MOROCCO [FR]",
        description:
          "With G. Recorbet – General Manager Servier Morocco, A. Dakki – Human Resources Manager Servier Morocco, Khadija Amrani – Marketing Director Servier Morocco, Nour Alamy – Pharmaceutical Affairs Director Servier Morocco Hosted by A. Eral",
      },
      {
        date: "May 11th 15:00 - 16:15",
        place: "Paris",
        title: "BLUE OCEAN STRATEGY BY MARVEL STUDIOS [ENG] ",
        description:
          "With D. Maisel (founding CEO – Marvel Studios), J. Hunter (Senior Blue Ocean Strategy Practitioner) Hosted by M. Olenick (Institute Executive Fellow – INSEAD Blue Ocean Strategy Institute)",
      },
    ],
    boothList: [
      {
        id: "1",
        title: "Organizers & Major Sponsors",
        booths: [
          {
            id: "11",
            title: "Blue Ocean Awards",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FKQ1gHZ9qhdSrfJFqK4sWa5pfFK13%2F1620707889044-1620707650000-boa-logo.jpg?alt=media&token=40772d41-84cf-4f43-8822-154f059b69f2",
          },
          {
            id: "22",
            title: "HEC Paris",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FKQ1gHZ9qhdSrfJFqK4sWa5pfFK13%2F1620708186869-1620708168000-hec.jpg?alt=media&token=522946e2-01ac-4603-9b2c-970f71e45eb4",
          },
          {
            id: "33",
            title: "MICHELIN",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FXwfiVoqPFPfFaOpT1A6Y6grSUmz1%2F1620124422389-1619840753960-Michelin_G_S_Fr_WhiteBG_RGB_0618-01.png?alt=media&token=647e64e4-08b8-4b27-b654-6c1b2de273ab",
          },
        ],
      },
      {
        id: "2",
        title: "Sponsors",
        booths: [
          {
            id: "11",
            title: "France Batter",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FKQ1gHZ9qhdSrfJFqK4sWa5pfFK13%2F1620707997278-1620707781000-france-barter.jpg?alt=media&token=091fff75-5b73-4251-8f9f-be3ee9e1b98c",
          },
          {
            id: "22",
            title: "HUB 612",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1620318148654-1620318124365-WhatsApp%20Image%202021-05-06%20at%209.52.00%20PM.jpeg?alt=media&token=5626bdc0-4abc-454c-aa4e-c35121714478",
          },
        ],
      },
      {
        id: "3",
        title: "Partners",
        booths: [
          {
            id: "11",
            title: "Forbes",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy9uKcv7IeIWaKGCSGaap0LneIyD2%2F1620318729695-1620318714469-WhatsApp%20Image%202021-05-06%20at%2010.01.50%20PM.jpeg?alt=media&token=5e423ed2-7b07-44bb-8e83-fa24e6992ac5",
          },
          {
            id: "22",
            title: `Pink Innov'`,
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2Fy0Su0xVve2QuEwe7GED3OyKCf8a2%2F1619454679697-1476537658000-logo-pink-innov-texte-jpg.jpg?alt=media&token=94cbcc69-7457-43d0-9de1-22f47c967775",
          },
          {
            id: "33",
            title: "EngageX",
            image:
              "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2F0dl4HxLhbtUpWbeSlmGxtJI1PCo2%2F1620380265812-1620380246744-engagex%20(1).png?alt=media&token=fcb160ff-64a6-4dd0-a948-2209e53c7ad0",
          },
        ],
      },
    ],
    isEnrolled: true,
  },
];

export const consultList = [
  {
    id: 1,
    name: "Igesia Clinic",
    image: `${process.env.PUBLIC_URL + "/assets/dr-reena.jpeg"}`,
    date: "3 October, 2021",
    slug: "igesia-clinic",
  },
  {
    id: "3",
    isConsult: true,
    name:
      "Strategic Leadership of Industry 4.0: Smart Manufacturing for the 4th Industrial Revolution",
    description:
      "We are in the midst of the 4th Industrial Revolution (4IR). According to Professor Klaus Schwab, the Founder of the World Economic Forum, the speed of current breakthroughs has no historical precedent. When compared with previous industrial revolutions, the 4IR is evolving at an exponential rather than a linear pace. Moreover, it is disrupting almost every industry in every country. And the breadth and depth of these changes herald the transformation of entire systems of production, management, and governance.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Fstrategic-leadership-of-industry-4.jpg?alt=media&token=308f5ea6-a21e-43a5-bc59-a9b4d04f631d",
    date: "3 October, 2021",
    fee: "Starting INR 2000",
    feeValue: 2000,
    providers: [
      {
        name: "Professor Soumitra Dutta",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Soumitra%20Dutta.jpg?alt=media&token=9c560b2f-7c85-4462-b2cc-2faa00633799",
        designation: "Cornell University",
        id: "1",
        username: "soumitra",
        email: "soumitra@igesia.co",
        address: "New York",
        description:
          "Soumitra Dutta is a Professor of Management at and the former founding dean of the SC Johnson College of Business at Cornell University, New York. He is the founder of the Global Innovation Index, published by the World Intellectual Property Organization and was the co-editor of the Global Information Technology Report, published by the World Economic Forum – two influential reports in technology and innovation policy. He is also the founder and President of Portulans Institute, a non-partisan nonprofit research and education institution based in Washington DC.",
      },

      {
        name: "Professor Tawfik Jelassi",
        avatar: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/jelasi.jpg",
        designation: "IMD",
        id: "3",
        username: "tafik",
        email: "tafik@gmail.com",
        address: "United States",
        description:
          "Tawfik Jelassi is Professor of Strategy and Technology Management at IMD. He is also Co-Director of the Orchestrating Winning Performance (OWP) program in Lausanne and Singapore/Dubai, which is the school’s largest executive education program with over 600 participants enrolled per year. His major research, teaching and consulting interests are in the areas of digital business transformation and leadership in turbulent times. He was granted several excellence awards for his teaching and research in Europe and the USA, and has received two national decorations from the President of Tunisia: “The Order of merit in the fields of education and science” and “The Order of the Republic”.",
      },
    ],

    notificationList: [
      {
        message: "Provider shared a document Note101.pdf",
      },
      { message: "Provider shared a document Note54.ppt" },
      { message: "Provider started a Live Session" },
      { message: "Provider updated the pricing to Starting INR 2000" },
    ],

    peopleList: [
      {
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
        username: "lim",
      },
      {
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
        username: "shayat",
      },
      {
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
        username: "siddhesh",
      },
      {
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
        username: "richard",
      },
      {
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
        username: "sathvik",
      },
    ],
    courseContent: [
      {
        name: "Disruptive technologies",
        subContent: [
          { name: "Course introduction", id: "1", details: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            details: "LIVE 30:00",
          },
        ],
        id: "1111",
        details: "2 lectures - 36 min",
      },
      {
        name: "Leading transformation and innovation",
        subContent: [
          { name: "Course introduction", id: "1", details: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            details: "LIVE 30:00",
          },
        ],
        id: "92121",
        details: "2 lectures - 36 min",
      },
      {
        name: "Industry 4.0 culture and mindsets",
        subContent: [
          { name: "Course introduction", id: "1", details: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            details: "LIVE 30:00",
          },
        ],
        id: "2121",
        details: "2 lectures - 36 min",
      },
    ],
  },

  {
    id: "2",
    isConsult: true,
    name: "Cyber security for Digital Leadership",
    description:
      "In today’s Information Age, as business, governments, Public Sector Units, financial institutions, and individuals converge on the digital market space, generation, collection, processing, storage, and data exchange has become an integral part of digital transaction and interactions. In parallel, cyber security threats and cyber-attacks by hackers exploiting vulnerabilities of an organization’s cyber security is a common phenomenon. As a result, cyber risk management has become a fundamental component of business operations and understanding and mitigating risk has become an essential skill for business leaders, thought leaders, analysts, as well as security and technology specialists",
    image:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Fcyber-security-for-digital-leadership.jpg?alt=media&token=ec7eedb0-815a-451b-8c96-faf95d10f5bc",
    // speciality: 'Psychologist',
    date: "14 October, 2021",
    fee: "Starting INR 10000",
    feeValue: 10000,
    providers: [
      {
        name: "Dr. Elena Kvochko",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FElena%20Kvochko.jpg?alt=media&token=2f6c388b-4e90-4ea6-9d51-692c293c8d3a",
        designation: "Chief Trust Officer, SAP",
        id: "1",
        username: "elena",
        email: "elena@gmail.com",
        address: "New York",
        // isDoctor: true,
        description:
          "Elena Kvochko is the Chief Trust Officer at SAP New York. She is a Certified Information Security Professional (CISSP) and has been on The Wall Street Journal CIO Council, Board of Advisors at Obsidian Security, Senior Vice- President, and Technology Executive at Bank of America. Previously, she worked as Chief Information Officer of the Global Security Division, and Head of Global Cyber Security Strategy Implementation at Barclays.",
      },
      {
        name: "Professor William H. Dutton",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20William%20H.%20Dutton.jpg?alt=media&token=706ca6f3-92d7-4c3e-aebe-b251c79a2d02",
        designation: "Professor, University of Southern California",
        id: "2",
        username: "william",
        email: "william@gmail.com",
        address: "New York",
        // isDoctor: true,
        description:
          "William H. Dutton is an Emeritus Professor at the University of Southern California, an Oxford Martin Fellow, supporting the Global Cyber Security Capacity Centre at the University of Oxford’s Department of Computer Science, and a Senior Fellow at the Oxford Internet Institute (OII). He is also a Visiting Professor at Leeds University. Recently, Bill was the James H. Quello Professor of Media and Information Policy at Michigan State University, where he was Director of the Quello Center. Prior to that, he was the OII’s Founding Director and the first Professor of Internet Studies at Oxford University. Most recently he co-edited, with Mark Graham, Society, and the Internet, 2nd ed (Oxford Un Press 2019), and edited A Research Agenda for Digital Politics (Elgar 2020). His next book will be The Fifth Estate (Oxford Un Press).",
      },
      {
        name: "Professor Bhavani Thuraisingham",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Bhavani%20Thuraisingham.jpg?alt=media&token=fd6c88a9-ed23-4cc0-bbb5-c7b876f15059",
        designation: "Executive Director, Cyber Security Research",
        id: "3",
        username: "bhavani",
        email: "bhavani@gmail.com",
        address: "New York",
        // isDoctor: true,
        description:
          "Dr. Bhavani Thuraisingham is the Louis A. Beecherl, Jr. Distinguished Professor of Computer Science and the Executive Director of the Cyber Security Research and Education Institute at the University of Texas, Dallas. She is also a visiting Senior Research Fellow at Kings College, University of London, and a Fellow of the ACM, IEEE, and the AAAS.",
      },
    ],
    notificationList: [
      {
        message: "Provider shared a document Note101.pdf",
      },
      { message: "Provider shared a document Note54.ppt" },
      { message: "Provider started a Live Session" },
      { message: "Provider updated his description" },
    ],
  },
];

export const myConsultList = [
  {
    id: "3",
    isConsult: true,
    name:
      "Strategic Leadership of Industry 4.0: Smart Manufacturing for the 4th Industrial Revolution",
    description:
      "We are in the midst of the 4th Industrial Revolution (4IR). According to Professor Klaus Schwab, the Founder of the World Economic Forum, the speed of current breakthroughs has no historical precedent. When compared with previous industrial revolutions, the 4IR is evolving at an exponential rather than a linear pace. Moreover, it is disrupting almost every industry in every country. And the breadth and depth of these changes herald the transformation of entire systems of production, management, and governance.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Fstrategic-leadership-of-industry-4.jpg?alt=media&token=308f5ea6-a21e-43a5-bc59-a9b4d04f631d",
    date: "3 October, 2021",
    fee: "Starting INR 2000",
    feeValue: 2000,
    providers: [
      {
        name: "Professor Soumitra Dutta",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Soumitra%20Dutta.jpg?alt=media&token=9c560b2f-7c85-4462-b2cc-2faa00633799",
        designation: "Cornell University",
        id: "1",
        username: "soumitra",
        email: "soumitra@igesia.co",
        address: "New York",
        description:
          "Soumitra Dutta is a Professor of Management at and the former founding dean of the SC Johnson College of Business at Cornell University, New York. He is the founder of the Global Innovation Index, published by the World Intellectual Property Organization and was the co-editor of the Global Information Technology Report, published by the World Economic Forum – two influential reports in technology and innovation policy. He is also the founder and President of Portulans Institute, a non-partisan nonprofit research and education institution based in Washington DC.",
      },

      {
        name: "Professor Tawfik Jelassi",
        avatar: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/jelasi.jpg",
        designation: "IMD",
        id: "3",
        username: "tafik",
        email: "tafik@gmail.com",
        address: "United States",
        description:
          "Tawfik Jelassi is Professor of Strategy and Technology Management at IMD. He is also Co-Director of the Orchestrating Winning Performance (OWP) program in Lausanne and Singapore/Dubai, which is the school’s largest executive education program with over 600 participants enrolled per year. His major research, teaching and consulting interests are in the areas of digital business transformation and leadership in turbulent times. He was granted several excellence awards for his teaching and research in Europe and the USA, and has received two national decorations from the President of Tunisia: “The Order of merit in the fields of education and science” and “The Order of the Republic”.",
      },
    ],

    notificationList: [
      {
        message: "Provider shared a document Note101.pdf",
      },
      { message: "Provider shared a document Note54.ppt" },
      { message: "Provider started a Live Session" },
      { message: "Provider updated the pricing to Starting INR 2000" },
    ],

    peopleList: [
      {
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
        username: "lim",
      },
      {
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
        username: "shayat",
      },
      {
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
        username: "siddhesh",
      },
      {
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
        username: "richard",
      },
      {
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
        username: "sathvik",
      },
    ],
    courseContent: [
      {
        name: "Disruptive technologies",
        subContent: [
          { name: "Course introduction", id: "1", details: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            details: "LIVE 30:00",
          },
        ],
        id: "1111",
        details: "2 lectures - 36 min",
      },
      {
        name: "Leading transformation and innovation",
        subContent: [
          { name: "Course introduction", id: "1", details: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            details: "LIVE 30:00",
          },
        ],
        id: "92121",
        details: "2 lectures - 36 min",
      },
      {
        name: "Industry 4.0 culture and mindsets",
        subContent: [
          { name: "Course introduction", id: "1", details: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            details: "LIVE 30:00",
          },
        ],
        id: "2121",
        details: "2 lectures - 36 min",
      },
    ],
    isEnrolled: true,
  },
];

export const courseList = [
  {
    id: "1",
    name: "Innovation Management: Strategy and Execution",
    slug: "innovation-management-strategy-and-execution",
    description:
      "Innovation has become critical for winning in the marketplace. Several forces of change including technological progress, demographic shifts, changing customer demands and global competition have increased the need for companies to excel in innovation. ",
    image:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Finnovation-management-strategy-and-execution.jpg?alt=media&token=9ef98967-c7bd-4f67-8d64-048225b069a5",

    fee: "₹95,000",
    feeValue: 95000,
    date: "30 October, 2021",
    courseFeatures: [
      "Creativity and ideation",
      "Innovation readiness",
      "Innovation leadership",
    ],
    courseRequirements: [
      "A device with active internet connection",
      "High school maths",
    ],
    providers: [
      {
        name: "Professor Soumitra Dutta",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Soumitra%20Dutta.jpg?alt=media&token=9c560b2f-7c85-4462-b2cc-2faa00633799",
        designation: "Cornell University",
        id: "1",
        username: "soumitra",
        email: "soumitra@igesia.co",
        address: "New York",
        description:
          "Soumitra Dutta is a Professor of Management at and the former founding dean of the SC Johnson College of Business at Cornell University, New York. He is the founder of the Global Innovation Index, published by the World Intellectual Property Organization and was the co-editor of the Global Information Technology Report, published by the World Economic Forum – two influential reports in technology and innovation policy. He is also the founder and President of Portulans Institute, a non-partisan nonprofit research and education institution based in Washington DC.",
        certification: 14,
        followers: 1251,
        podcasts: 43,
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        qualifications: "Phd, MS, Btech",
      },
      // {
      //   name: 'Dr. Dongmin Chen',
      //   avatar:
      //     'https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FDr.%20Dongmin%20Chen.jpg?alt=media&token=ccd8be2b-8ca0-4a39-a4d3-2e31a905faff',
      //   designation: 'Peking University',
      //   id: '2',
      //   username: 'dongmin_chen',
      //   email: 'dongmin@gmail.com',
      //   address: 'United States',
      // },
      // {
      //   name: 'Professor Tawfik Jelassi',
      //   avatar: 'https://igesia.co/assets/jelasi.jpg',
      //   designation: 'IMD',
      //   id: '3',
      //   username: 'tafik',
      //   email: 'tafik@gmail.com',
      //   address: 'United States',
      // },
      {
        name: "Professor Bruno Lanvin",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Bruno%20Lanvin.jpg?alt=media&token=ca7673d5-6e39-4b78-9620-056deaae5a3a",
        designation: "President, Smart City Observatory",
        id: "4",
        username: "bruna_lanvin",
        email: "bruno@gmail.com",
        address: "United States",
        description:
          "Dr Bruno Lanvin is the President of the Smart City Observatory. He is also Executive Director of INSEAD’s Global Indices, founder and CEO of D&L Partners, and co-founder and director of Portulans Institute. He has exercised senior responsibilities at the World Bank and in the United Nations.",
        certification: 14,
        followers: 1251,
        podcasts: 43,
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        qualifications: "Phd, MS, Btech",
      },
    ],

    notificationList: [
      {
        message: "Instructor shared a document LectureNote101.pdf",
      },
      { message: "Instructor shared a document LectureNote54.ppt" },
      { message: "Instructor started a Live Session" },
      { message: "Instructor updated the course description" },
    ],

    peopleList: [
      {
        id: 1,
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
        username: "lim",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 14,
        followers: 1251,
        podcasts: 43,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 2,
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
        username: "shayat",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 10,
        followers: 1051,
        podcasts: 23,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 3,
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
        username: "siddhesh",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 11,
        followers: 1951,
        podcasts: 21,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 4,
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
        username: "richard",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 16,
        followers: 1361,
        podcasts: 15,
        qualifications: "Phd, MS, Btech",
        following: false
      },
      {
        id: 5,
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
        username: "sathvik",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 11,
        followers: 963,
        podcasts: 9,
        qualifications: "Phd, MS, Btech",
        following: false
      },
    ],
    courseContent: [
      {
        name: "Creativity and ideation",
        subContent: [
          {
            name: "Course introduction",
            id: "1",
            length: "6:59",
            documents: [
              {
                title: "Introduction.pdf",
                url: "http://www.africau.edu/images/default/sample.pdf",
                id: "313",
              },
            ],
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",

            details:
              "The program will describe approaches to enhancing creativity and the process of ideating new products and services. Approaches such as design thinking and Blue Ocean strategy will be highlighted as approaches to enhancing creativity and coming up with new products and service ideas",
          },
          {
            name: "AI Basics quiz",
            id: "1234234",
            isQuiz: true,
            question: "Who is the father of artificial intelligence?",
            multiple: false,
            answers: [1],
            options: [
              {
                id: 1,
                value: "John McCarthy",
              },
              {
                id: 2,
                value: "Fisher Ada",
              },
              {
                id: 3,
                value: "Allen Newell",
              },
              {
                id: 4,
                value: "Alan Turning",
              },
            ],
          },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [],
            details:
              "The program will describe approaches to enhancing creativity and the process of ideating new products and services. Approaches such as design thinking and Blue Ocean strategy will be highlighted as approaches to enhancing creativity and coming up with new products and service ideas",
          },
          {
            name: "AI Assignment 1",
            question: "Describe artificial intelligence?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "1111",
        details: "2 lectures - 36 min",
      },
      {
        name: "Innovation readiness",
        subContent: [
          {
            name: "Course introduction",
            id: "1",
            length: "6:59",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [
              {
                title: "Introduction.pdf",
                url: "http://www.africau.edu/images/default/sample.pdf",
                id: "313",
              },
            ],
            details:
              "Companies have to work on multiple dimensions to enhance their innovation readiness. Investments in human talent have to be complemented by new processes and appropriate technologies",
          },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [],
            details:
              "Companies have to work on multiple dimensions to enhance their innovation readiness. Investments in human talent have to be complemented by new processes and appropriate technologies",
          },
        ],
        id: "92121",
        details: "2 lectures - 36 min",
      },
      {
        name: "Innovation leadership",
        subContent: [
          {
            name: "Course introduction",
            id: "1",
            length: "6:59",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [
              {
                title: "Introduction.pdf",
                url: "http://www.africau.edu/images/default/sample.pdf",
                id: "313",
              },
            ],
            details:
              "Rigorous and disciplined execution is essential for innovation leadership. The program will outline the key essentials of managing the innovation process and also describe strategies adopted by different firms to drive innovation such as the creation of innovation labs and corporate ventures",
          },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [],
            details:
              "Rigorous and disciplined execution is essential for innovation leadership. The program will outline the key essentials of managing the innovation process and also describe strategies adopted by different firms to drive innovation such as the creation of innovation labs and corporate ventures",
          },
        ],
        id: "2121",
        details: "2 lectures - 36 min",
      },
    ],
    isCourse: true,
  },
  {
    id: "2",
    isCourse: true,
    name: "Artificial Intelligence: Principles and Techniques",
    slug: "artificial-intelligence-principles-and-techniques",
    description:
      "Artificial Intelligence (AI) has emerged as one of the most important disruptions facing business and society over the next several decades. The confluence of rapid progress in computation, big data and analytics has accelerated technological change and has introduced a new urgency into understanding the impact of AI on business, government and society.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Fartificial-intelligence-principles-and-techniques.jpg?alt=media&token=bb045d37-d0b9-4b06-84a1-041e1989ca60",

    fee: "₹95,000",
    feeValue: 95000,
    date: "3 October, 2021",
    courseFeatures: [
      "Creativity and ideation",
      "Innovation readiness",
      "Innovation leadership",
    ],
    courseRequirements: [
      "A device with active internet connection",
      "High school maths",
    ],
    providers: [
      {
        name: "Professor Soumitra Dutta",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Soumitra%20Dutta.jpg?alt=media&token=9c560b2f-7c85-4462-b2cc-2faa00633799",
        designation: "Cornell University",
        id: "1",
        username: "soumitra",
        email: "soumitra@igesia.co",
        address: "New York",
        description:
          "Soumitra Dutta is a Professor of Management at and the former founding dean of the SC Johnson College of Business at Cornell University, New York. He is the founder of the Global Innovation Index, published by the World Intellectual Property Organization and was the co-editor of the Global Information Technology Report, published by the World Economic Forum – two influential reports in technology and innovation policy. He is also the founder and President of Portulans Institute, a non-partisan nonprofit research and education institution based in Washington DC.",
        certification: 14,
        followers: 1251,
        podcasts: 43,
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        qualifications: "Phd, MS, Btech",
      },
      // {
      //   name: 'Dr. Dongmin Chen',
      //   avatar:
      //     'https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FDr.%20Dongmin%20Chen.jpg?alt=media&token=ccd8be2b-8ca0-4a39-a4d3-2e31a905faff',
      //   designation: 'Peking University',
      //   id: '2',
      //   username: 'dongmin_chen',
      //   email: 'dongmin@gmail.com',
      //   address: 'United States',
      // },
      // {
      //   name: 'Professor Tawfik Jelassi',
      //   avatar: 'https://igesia.co/assets/jelasi.jpg',
      //   designation: 'IMD',
      //   id: '3',
      //   username: 'tafik',
      //   email: 'tafik@gmail.com',
      //   address: 'United States',
      // },
      {
        name: "Professor Amit Basu",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Amit%20Basu.jpg?alt=media&token=a1d95aa6-7772-4303-8564-84b69c971f76",
        designation: "Southern Methodist University (SMU)",
        id: "4",
        username: "amit_basu",
        email: "amitbasu@gmail.com",
        address: "United States",
        description:
          "Professor Amit Basu is the Carr P. Collins Endowed Chair at the Cox School of Business at Southern Methodist University in Dallas, where he also chairs the IT and Operations Management department. Professor Basu has also been a faculty member at Vanderbilt University and the University of Maryland at College Park, and a visiting professor at INSEAD, the Vlerick Management School in Belgium and the Indian Institute of Management.",
        certification: 14,
        followers: 1251,
        podcasts: 43,
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        qualifications: "Phd, MS, Btech",
      },
    ],

    notificationList: [
      {
        message: "Instructor shared a document LectureNote101.pdf",
      },
      { message: "Instructor shared a document LectureNote54.ppt" },
      { message: "Instructor started a Live Session" },
      { message: "Instructor updated the course designation" },
    ],

    peopleList: [
      {
        id: 1,
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
        username: "lim",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 14,
        followers: 1251,
        podcasts: 43,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 2,
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
        username: "shayat",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 10,
        followers: 1051,
        podcasts: 23,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 3,
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
        username: "siddhesh",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 11,
        followers: 1951,
        podcasts: 21,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 4,
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
        username: "richard",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 16,
        followers: 1361,
        podcasts: 15,
        qualifications: "Phd, MS, Btech",
        following: false
      },
      {
        id: 5,
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
        username: "sathvik",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 11,
        followers: 963,
        podcasts: 9,
        qualifications: "Phd, MS, Btech",
        following: false
      },
    ],

    courseContent: [
      {
        name: "Core AI technologies",
        subContent: [
          { name: "Course introduction", id: "1", length: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
          },
        ],
        id: "1111",
        details: "2 lectures - 36 min",
      },
      {
        name: "Innovative business applications of AI",
        subContent: [
          { name: "Course introduction", id: "1", length: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
          },
        ],
        id: "92121",
        details: "2 lectures - 36 min",
      },
      {
        name: "Human and societal implications of AI",
        subContent: [
          { name: "Course introduction", id: "1", length: "6:59" },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
          },
        ],
        id: "2121",
        details: "2 lectures - 36 min",
      },
    ],
  },
  {
    id: "3",
    name: "GBSN Online Teachers' Training Seminar",
    slug: "gbsn-online-teachers-training-seminar",
    description: `The ongoing Covid crisis has triggered one of the biggest changes in recent decades within educational institutions. Teaching in most schools and universities has moved online and both faculty and students have been forced to come to terms rapidly with a whole new way of teaching and learning. While the ongoing global roll-out of the Covid vaccine shows a way out of the health crisis, most educators believe that online teaching is here to stay and will become an increasingly important part of education going forward.

      This disruption in the education system is an opportunity to further innovation in pedagogy and learning. Online teaching itself will evolve in the coming years and faculty will need to rethink many aspects of how they teach and engage with students online. GBSN is pleased to present a certificate program for online teaching. This certificate program is being offered in partnership with the Portulans Institute (a Washington, DC based not-for-profit research institute), Igesia.co (a digital learning education tech company) and the Confederation of Indian Industry (CII).
      
      General Information
      This certificate program has been designed to help faculty make online teaching more effective and efficient. The program will consist of ten live virtual interactive workshops, each hosted by relevant experts addressing key themes as outlined in the figure below.
      
      Each session is designed to be interactive and will be 60 mins in duration. Program participants will be provided instructions and materials prior to each session to adequately prepare.`,
    image: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/GBSN-teacherstraining.png",
    logo_image: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/gbsn_logo.svg",
    fee: "₹95,000",
    feeValue: 95000,
    date: "30 October, 2021",
    courseFeatures: [
      "Creativity and ideation",
      "Innovation readiness",
      "Innovation leadership",
    ],
    courseRequirements: [
      "A device with active internet connection",
      "High school maths",
    ],
    providers: [
      {
        name: "Soumitra Dutta",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Soumitra%20Dutta.jpg?alt=media&token=9c560b2f-7c85-4462-b2cc-2faa00633799",
        designation:
          "Professor of Management Cornell SC Johnson College of Business USA Board Chair",
        id: "1",
        username: "soumitra_dutta",
        address: "New York",
        description: `Soumitra Dutta is a Professor of Management at and the former founding dean of the SC Johnson College of Business at Cornell University, New York. He is the founder of the Global Innovation Index, published by the World Intellectual Property Organization and was the co-editor of the Global Information Technology Report, published by the World Economic Forum – two influential reports in technology and innovation policy. He is also the founder and President of Portulans Institute, a non-partisan nonprofit research and education institution based in Washington DC.
          
          Dutta is on the global boards of Sodexo and Dassault Systemes. He is also a member of the Shareholder Council of Chicago-based healthcare consulting company ZS Associates. Dutta is a member of the Davos Circle, an association of long-time participants in the Annual Davos meeting of the World Economic Forum. He was the co-chair of the World Economic Forum’s Global Future Council on Innovation Ecosystems. He is also the Chief Academic Advisor to the Artificial Intelligence Forum of the Confederation of Indian Industry).`,
        certification: 14,
        followers: 1251,
        podcasts: 43,
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        qualifications: "Phd, MS, Btech",
      },
      {
        name: "Jens Meyer",
        avatar: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/Jens-Meyer.jpg",
        designation:
          "Adjunct Professor; Dean of Programmes INSEAD; CEDEP France",
        id: "4",
        username: "jens_meyer",
        address: "United States",
        description: `Jens Meyer’s teaching and development focuses on innovation and change. His approach is to explore industrial or managerial beliefs, reveal dysfunctional aspects and proposes means and measures to overcome them.

          He is the Dean of Programmes at CEDEP and Adjunct Professor at INSEAD, and holds appointments at other academic institutions such as the University of Applied Science of Worms (Fachhochschule Worms).
          
          Jens graduated with an MBA in Innovation, Strategy and Information Technology in 1992 from the French Business School Theseus at Sophia Antipolis. He then went to INSEAD, Fontainebleau, where he co-founded the Centre for Advanced Learning Technologies.
          
          He has developed and taught courses on a variety of subjects including: Cyber-Entrepreneurship (Entrepreneurial Innovation in the context of Business Start-ups), Business Intelligence, Fair Process & Change Management, Blue Ocean Strategy & Value Innovation. He has lectured and presented in executive programs and gatherings throughout Europe and the US for more than 50 groups and clients over the last 10 years.
          
          Jens is a cofounder of Strategy Regeneration Ltd. – a company based in Dublin, Ireland which designs and delivers project coaching and facilitation to a broad range of businesses and functions; the Strategy Regeneration offer has been in the market for over two years.`,
        certification: 14,
        followers: 1251,
        podcasts: 43,
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        qualifications: "Phd, MS, Btech",
      },
    ],

    notificationList: [
      {
        message: "Instructor shared a document LectureNote101.pdf",
      },
      { message: "Instructor shared a document LectureNote54.ppt" },
      { message: "Instructor started a Live Session" },
      { message: "Instructor updated the course description" },
    ],

    peopleList: [
      {
        id: 1,
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
        username: "lim",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 14,
        followers: 1251,
        podcasts: 43,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 2,
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
        username: "shayat",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 10,
        followers: 1051,
        podcasts: 23,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 3,
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
        username: "siddhesh",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 11,
        followers: 1951,
        podcasts: 21,
        qualifications: "Phd, MS, Btech",
        following: true
      },
      {
        id: 4,
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
        username: "richard",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 16,
        followers: 1361,
        podcasts: 15,
        qualifications: "Phd, MS, Btech",
        following: false
      },
      {
        id: 5,
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
        username: "sathvik",
        country: "United States",
        specialties:
          "Innovation, Artificial Intelligence, Services Operations Management, Technology Strategy",
        certification: 11,
        followers: 963,
        podcasts: 9,
        qualifications: "Phd, MS, Btech",
        following: false
      },
    ],
    roomList: [
      {
        videoServerId: "ap-south-1.igesia.com",
        inviteCode: "506288",
        roomName: "Online Teachers' Training Seminar",
        lastMessage: {
          user: {
            name: "Shefali  Rai",
            id: "NVuGhdsP2BOpIxciHpF0l0YTmVh2",
            avatar:
              "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/avatars%2Fusers%2Fsolo-icon.svg?alt=media&token=0279ff83-ebf4-420f-bc28-e5f6b10a7822",
          },
          timestamp: 1620978198371,
          content:
            "Hello Nalinie, you should be able to view the videos. Please let me know if you are not able to.",
          type: 0,
          uid: "jugkeQ0eGK97wLIC5QNc",
          createdAt: { seconds: 1614674851, nanoseconds: 85000000 },
        },
        roomStatus: 0,
        roomIdLowerCase: "yewefgu7knfnoy5dhcxg",
        roomType: 0,
        description: "",
        createdBy: "NVuGhdsP2BOpIxciHpF0l0YTmVh2",
        roomPic:
          "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/avatars%2Fworkspaces%2FAzspVuqB0UIg0jgVOwtW%2Frooms%2FYeWEFgU7knfNOy5DHcxg?alt=media&token=df6a9ef0-20e2-4eb1-ac22-4a5164a030ea",
        createdAt: 1613456219906,
        roomId: "YeWEFgU7knfNOy5DHcxg",
      },
    ],
    courseContent: [
      {
        name: "Session 1: Changes for teacher and how do people learn online",
        subContent: [
          {
            name: "Session by Dr. Jens Meyer, January 29 2021",
            id: "1",
            length: "51:38",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613462903031-1611672819172-Topic%201-%20Changes%20for%20teacher%20and%20how%20do%20people%20learn%20online-%20Brief-%20Jan%2029%202021.pdf?alt=media&token=37bfa6e1-0e61-41fb-8b21-5753cf2aa3e5",
                id: 1,
                type: "application/pdf",
              },
              {
                title: "Presentation Slides",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613462905341-1612447052855-Topic%201-%20Changes%20for%20teacher%20and%20how%20do%20people%20learn%20online-PPT-%20Jan%2029%202021.pptx?alt=media&token=355ca082-d36e-4e9e-be0f-f140db6dbb63",
                id: 2,
                type: "application/pptx",
              },
              {
                title: "Graphic Illustration 1",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613634277883-1612447256594-Graphic%201.jpeg?alt=media&token=6cd05a0d-48ad-4a9b-a5ca-a638fee11530",
                id: 3,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 2",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613634396049-1612447265106-Graphic%202.jpeg?alt=media&token=ea59dcec-fb5c-4adc-87b4-1a464e35eecb",
                id: 4,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 3",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613634429026-1612447272974-Graphic%203.jpeg?alt=media&token=f9a3e4e7-5a9e-4c34-b63f-59f34202083e",
                id: 5,
                type: "image/jpeg",
              },
              {
                title: "Chat Window Comments",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975337502-1613974919195-Session%201%20Chat%20Window%20Comments.txt?alt=media&token=9745047a-0976-43c3-b9be-b7642fdd5ebe",
                id: 6,
                type: "text/plain",
              },
            ],
            lessonUrl: "https://youtu.be/Qi5OTijcoTs",

            details: `1. Online teaching has multiple modes (synchronous/asynchronous) and formats (blended, flipped etc) which are widely used with mixed results. By taking certain factors into account, such as size of class, type of course, frequency of classes per week, access to technology etc., it is easier to understand the correct balance of synchronous and asynchronous material in the blended/online format.

              2. While the COVID-19 pandemic has made online teaching and learning mandatory, this has been a challenge for both faculty and students alike. Issues range from lack of easy access to technological tools to lack of inclusiveness in teaching and even burn out from attending one online class after another with no/little time for breaks.
              
              3. Inspite of the operational pitfalls and logistical challenges, there is an opportunity to increase the effectiveness of the various modes and formats in online teaching. Additionally, there is also scope to experiment with these to customize the learning goals more closely with the students’ needs. For example, by redesigning the course work there can be a more class quizzes in real time which assess how students are learning vs standard exams at the end of the semester. This not only keeps students actively engaged but also provided faculty with real time feedback on improving course content/structure or teaching style.
              
              4. The other opportunities associated with online teaching pertain to better time management of classes and designing classes to become more inclusive. In comparison the traditional in person teaching classes would often run over schedule and would rarely align with the various learning styles, relying on the standard ‘presentation and lecture’ mode of teaching.
              
              5. Here is a question for you: Can you think of 2-3 situations where you found online teaching very stressful or challenging? You are encouraged to write this down and bring it to our discussion on Friday,29th Jan 2021.`,
          },
          {
            name: "Assignment 1",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "1111",
        details: "1 lecture - 52 min",
      },
      {
        name: "Session 2: The Field of Learning Technology",
        subContent: [
          {
            name: "Session by Dr. Soumitra Dutta, February 5th 2021",
            id: "1",
            length: "01:00:40",
            lessonUrl: "https://youtu.be/YtT28pN1bg4",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613458541619-1612415538504-Topic%202-The%20Field%20of%20Learning%20Technology-Brief-Feb%205th%202021.pdf?alt=media&token=1510dd17-a2f1-4ffa-892c-c918c774bb44",
                id: 1,
                type: "application/pdf",
              },
              // {
              //   title: "Presentation Slides",
              //   url: "https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613462905341-1612447052855-Topic%201-%20Changes%20for%20teacher%20and%20how%20do%20people%20learn%20online-PPT-%20Jan%2029%202021.pptx?alt=media&token=355ca082-d36e-4e9e-be0f-f140db6dbb63",
              //   id: 2,
              //   type: "application/pptx",
              // },
              {
                title: "Graphic Illustration 1",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613635211036-1613130941114-Graphic%20Illustration%201.jpeg?alt=media&token=2a70a2ea-3166-4c69-9479-9df69394216f",
                id: 3,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 2",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613635232263-1613130925244-Graphic%20Illustration%202.jpeg?alt=media&token=99f4615e-c5f8-477e-ab2e-cfa575f32a9f",
                id: 4,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 3",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613635259275-1613130932794-Graphic%20Illustration%203.jpeg?alt=media&token=3715ea27-574b-4c9e-bc0a-04188886177a",
                id: 5,
                type: "image/jpeg",
              },
              {
                title: "Chat Window Comments",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975368980-1613974955825-Session%202-%20Chat%20Window%20Comments.txt?alt=media&token=5141b63f-b7f6-4b0e-b82e-6da2dec77283",
                id: 6,
                type: "text/plain",
              },
            ],
            details: `1. The technology used in online education is referred to as instructional technology and is used in form of technological tools (software, programming languages), platforms (Zoom, Microsoft Teams etc), websites, services etc.

              Instructional technology is widely utilized in all elements of online/blended teaching and learning- from design, development, application, evaluation etc.
              
              2. Generally in online and blended teaching, technology has been used in design, delivery and evaluation of course content. But now given the uncertainty about return to the traditional method of in person teaching, technology is being used to redesign classroom dynamics to ensure effective learning outcomes. For example, teachers are beginning to use online tools more closely to facilitate collaborative work such as group assignments, breakout sessions etc.
              
              3. It is easier to use instructional technology in 3 distinct parts: before, during and after class. Technology before class can be used in preparation, during class for social learning and after class for out of class learning. Faculty can choose either asynchronous or synchronous mode for this.
              
              4. Instructional technology in asynchronous mode has increased flexibility in learning- students have greater freedom in deciding the pace of learning and can even self-monitor their progress. In the synchronous mode, students can provide immediate and real time feedback to instructors. A common example is, through an in-class quiz where responses are recorded in real time, students can understand immediately what concepts they understood well or not.
              
              4. However use of technology is sometimes restricted due to existing issues such as lack of equity in education. Example, issues such as intermittent access to electronic devices can be resolved through coursework that is designed with restricted technological access in mind. This highlights that the teaching experience needs to be customized with respect to need of students.
              
              5. Here is a question for you: What are the technological challenges that you or your students experience in/out of class? How have you helped to address this? Is there anyone experience that made you change the way you use technology in class?`,
          },
          {
            name: "Assignment 2",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 1 hour",
      },
      {
        name: "Session 3: Storytelling in Online Education",
        subContent: [
          {
            name: "Session by David Hutchens, February 12th 2021",
            id: "1",
            length: "01:24:19",
            lessonUrl: "https://youtu.be/-VOGbSUbDbc",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613459329850-1613024115328-Topic%203-%20Storytelling%20in%20Online%20Education-%20Brief-%20Feb%2012th%202021.pdf?alt=media&token=63ac4ed4-73a6-4b6b-9ca1-44b6dd4494d7",
                id: 1,
                type: "application/pdf",
              },
              {
                title: "Presentation Slides",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975547925-1613527179471-Session%203-Storytelling%20in%20Online%20Education-Ppt-Feb%2012%202021.pdf?alt=media&token=134a0e50-88cf-4af9-88cc-859e55b9270e",
                id: 2,
                type: "application/pptx",
              },
              {
                title: "Graphic Illustration 1",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975902886-1613738614139-Graphic%20Illustration%201.jpeg?alt=media&token=64346094-8a91-4c17-8e5e-0b6e0a8373aa",
                id: 3,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 2",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975925378-1613738623940-Graphic%20Illustration%202.jpeg?alt=media&token=8fad0a22-ac9c-43a9-8025-d9c7d4187e75",
                id: 4,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 3",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975947039-1613738633568-Graphic%20Illustration%203.jpeg?alt=media&token=39941009-065b-4fe5-929f-c0c820d670bd",
                id: 5,
                type: "image/jpeg",
              },
              {
                title: "Chat Window Comments",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975969999-1613974990740-Session%203%20Chat%20Window%20Comments.txt?alt=media&token=5b19c24f-c10b-4938-a311-4f3eb159a65f",
                id: 6,
                type: "text/plain",
              },
            ],
            details: `1. The term ‘Storytelling’ is self-explanatory: it is about telling stories using audio or visual tools.

            Storytelling has been a part of cultures across the world, useful in imparting important life lessons and in keeping traditions, value systems alive. Storytelling in classroom still remains one of the most powerful methods of conveying a message or lesson about life, society, people and much more. Research has proven that storytelling leads to better emotional cognition and improves long term memory.
            
            2. Storytelling has been found to be an essential component of online teaching irrespective of the mode of teaching- online/blended or synchronous/asynchronous. Effective storytelling is possible through drafts prepared from storyboards- this helps to decide the outline, format, content and overall structure of the story. Importantly, storyboards help to decide if the story should be linear or non-linear, that is should it follow a pre-decided structure or a flexible one, respectively.
            
            3. Certain aspects of storytelling need to be kept in mind while drafting the course content. One is simplicity in storytelling and the other is, type of media used in storytelling-static (documents/presentation slides) or interactive (audio/video). Using multimedia tools in storytelling allows the teacher to use static and interactive media simultaneously. This approach also engages the different types of learners that we have previously discussed: activist, reflector, theorist and pragmatist./n 4. It is important to look at storytelling as a component of online teaching and not use it as a tool by itself. Where storytelling is used in the class or course will determine what the end goal will be and vice versa. For example, storytelling can be used right at the beginning, middle or end of a class/course. At the beginning, storytelling can set the stage for learners and create curiosity, in the middle it can introduce/explain complex concepts/theories. When used at the end, storytelling can summarise the learning points.
            
            5. As with any course content, it is vital to have a strategy to evaluate the storytelling which will be used in class. Survey, quiz, short papers, briefs etc will reflect if the storytelling was able to achieve the teaching goals to help students understand, learn and apply the concept.
            
            6. Here is a question for you: How have you used storytelling in your course or class? What kind of tools have been the most supportive in your narration?`,
          },
          {
            name: "Assignment 3",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 1 hour 25 min",
      },
      {
        name: "Session 4: Icebreakers & More",
        subContent: [
          {
            name: "Session by Adrien Angliviel, February 19th 2021",
            id: "1",
            length: "01:02:51",
            lessonUrl: "https://youtu.be/nWajhYHZrtY",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613976269382-1613237530747-Topic%204%20-%20Icebreakers%20and%20more%20-%20Brief%20-%20Feb%2019%202021.pdf?alt=media&token=4178c602-b394-4972-aa53-7e960b1e75ab",
                id: 1,
                type: "application/pdf",
              },
              {
                title: "Presentation Slides",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613976328833-1613976122186-Session%204-%20Icebreakers%20%26%20More-%20PPT-%20Feb%2019%202021.pdf?alt=media&token=418f1792-7124-46aa-adc0-d4deb7abe744",
                id: 2,
                type: "application/pptx",
              },
              {
                title: "Graphic Illustration 1",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1614922941412-1614921983170-Graphic%20Illustration%201.jpeg?alt=media&token=4cce8b4f-fc47-46e2-a692-c933576de372",
                id: 3,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 2",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1614922965213-1614921996828-Graphic%20Illustration%202.jpeg?alt=media&token=0cd7d1aa-ce57-4267-a46f-6acda3be2de0",
                id: 4,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 3",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1614923009283-1614922011329-Graphic%20Illustration%203.jpeg?alt=media&token=c40de25b-b647-4925-a078-eb66ade8a8f0",
                id: 5,
                type: "image/jpeg",
              },
              {
                title: "Chat Window Comments",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1614923032987-1614922546097-Session%204%20Chat%20Window%20Comments.txt?alt=media&token=c369924d-17b6-46c7-aeef-ccdbab4d287c",
                id: 6,
                type: "text/plain",
              },
            ],
            details: `1. An important aspect of success in teaching the designed course, irrespective of format, is student engagement. For this, faculty should be able to hold the attention of the student in class. We have discussed some ways of achieving this, like using storytelling in class. There are other examples that can be used as extensively such as icebreakers and debriefs.

            2. An icebreaker is a fun, social activity that helps faculty and student to interact and get to know each other better. Icebreaker quite literally helps to break the ‘ice’ or tension in class and builds a more relaxed learning environment. Icebreakers also help students to know their classmates more closely and become well acquainted with the course content. Example of icebreakers are activities such as: Use 3 adjectives to describe yourself, find 3 things in common with your classmate etc.
            
            3. Icebreakers in online education is a healthy and constructive way to not only address learning anxiety but icebreaker activities also help prevent burnout which has been rampant from teaching/attending too many online classes.
            
            4. Even with this understanding of how critical icebreakers have become in the online environment, some faculty still struggle with being able to design a good icebreaker. Some of the best practises to design an icebreaker are: consider the size of class, if the icebreaker comes at the start/middle/end of class, length of activity.
            
            5. Debrief is a reflective activity that helps to summarise the course content either at the beginning or end of class provided by the faculty. Debrief entails providing students a high-level overview of the learning outcomes or what they have learnt at the end of the class. This allows students to be able to apply their learnings and process information better.
            
            6. Unlike an icebreaker, debriefs come strictly at the start or end of class and should always be a part of the lesson plan. One of the best practises with regards debrief is that, it maybe fine to shorten the actual teaching time but to not skip on debriefing.
            
            7. Here is a question for you: Which icebreaker activity in your class has been the most effective? How do students respond to debriefs in your class?`,
          },
          {
            name: "Assignment 4",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 1 hour 3 min",
      },
      {
        name:
          "Session 5: Building cognitive & socio-emotional connection in the online class",
        subContent: [
          {
            name: "Session by Nana Von Beruth, March 5th 2021",
            id: "1",
            length: "39:20",
            lessonUrl: "https://youtu.be/pOMN4TuXudo",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1615372480800-1614916507904-Topic%205-%20Building%20cognitive%20%26%20socio-emotional%20connection%20in%20the%20online%20class-%20Brief-%20March%205th%202021.pdf?alt=media&token=68e88cc0-930c-49b0-baf8-2f81d8539879",
                id: 1,
                type: "application/pdf",
              },
              // {
              //   title: "Presentation Slides",
              //   url: "https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613976328833-1613976122186-Session%204-%20Icebreakers%20%26%20More-%20PPT-%20Feb%2019%202021.pdf?alt=media&token=418f1792-7124-46aa-adc0-d4deb7abe744",
              //   id: 2,
              //   type: "application/pptx",
              // },
              {
                title: "Presentation Slides 2",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1616313029522-1616312953608-Topic%205-%20Building%20cognitive%20%26%20socio-emotional%20connection%20in%20the%20online%20class-%20PPT-%20March%205th%202021.pdf?alt=media&token=25442def-bf23-4e74-99fc-c089b328c42a",
                id: 2,
                type: "application/pptx",
              },
              // {
              //   title: "Graphic Illustration 1",
              //   url: "https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1614922941412-1614921983170-Graphic%20Illustration%201.jpeg?alt=media&token=4cce8b4f-fc47-46e2-a692-c933576de372",
              //   id: 3,
              //   type: "image/jpeg",
              // },
              {
                title: "Graphic Illustration 2",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1615372834563-1615368763513-2.jpeg?alt=media&token=9c571dd0-732f-4c18-9764-5ba95bd366f2",
                id: 4,
                type: "image/jpeg",
              },
              {
                title: "Chat Window Comments",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1615475379410-1615475322635-Chat%20Window%20Comments.txt?alt=media&token=234e3c18-36aa-4632-b3b7-5488afb35541",
                id: 6,
                type: "text/plain",
              },
            ],
            details: `1. One of the common grievances with online education is that it can become impersonal with little to no social interaction depending on the mode of teachingsynchronous/asynchronous. Designing an online course with synchronous/asynchronous components affects the scope of social interaction in class and vice-versa. Even then it may not be possible to always account for social interaction while selecting synchronous/asynchronous mode in class. In such situations, faculty need to be mindful of the cognitive and social presence in class, especially when the mode of teaching is asynchronous.

            2. What is the cognitive and social presence in class?
            
            Cognitive presence in class can be defined as the extent to which cognition is applied by students in the learning process. Concepts that can be understood, learnt, applied through collective discussion and discourse or through self-reflection require cognition.
            
            Social presence in class can be defined as the extent of human connection in the learning/teaching process. Simply put, having a ‘real’ face and voice in class counts as social presence. Not only is social presence fundamental to building a community but also helps in motivating students to interact more in class.
            
            3. The extent of cognition applied in the learning process by students, depends on the learning outcomes, performance expectations and content objectives. Similarly, social presence depends on choice of teaching mode and how faculty develop a channel of communication before and after class.
            
            So, how can faculty ensure a high cognitive and social presence in class? Cognitive presence can be higher when past knowledge is connected with the current learning material. Social presence will be higher when there is a certain emotional quotient involved in teaching. Certain activities can either address cognitive and social presence independently or simultaneously through asynchronous or synchronous mode respectively. Example, activities such as ice breakers require socio-emotional presence whereas activities such as quizzes depend on cognitive presence. Group assignments necessitate cognitive and socio-emotional presence simultaneously.
            
            4. Here is a question for you:
            
            What percentage of your course is synchronous and how much is asynchronous? How did you determine the choice of either-or balance between both to ensure that there is sufficient cognitive and social presence?`,
          },
          {
            name: "Assignment 5",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 40 min",
      },
      {
        name: "Session 6: How to create real learning dynamics?",
        subContent: [
          {
            name: "Session by Frank Azimont, March 12th 2021",
            id: "1",
            length: "48:15",
            lessonUrl: "https://youtu.be/D1gQlbLdDE0",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1616313701360-1615475937605-Topic%206%20-%20How%20to%20create%20the%20real%20learning%20dynamics-%20Brief-%20March%2012th%202021.pdf?alt=media&token=7f47c346-159a-48f8-9787-188e66f9ab8b",
                id: 1,
                type: "application/pdf",
              },
              {
                title: "Graphic Illustration 1",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1616313701406-1616312762364-1.jpeg?alt=media&token=56744d79-646b-48a2-96de-2ba3d51fc72f",
                id: 3,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 2",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1616313716759-1616312778472-2.jpeg?alt=media&token=533d3318-f754-4a56-8f08-ac96d39430d6",
                id: 4,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 3",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1616313732137-1616312791047-3.jpeg?alt=media&token=715e325e-9fd3-4d99-8174-c222bdcc3592",
                id: 6,
                type: "image/jpeg",
              },
            ],
            details: `1. One of the inherent advantages of online education is how dynamic it is compared to the traditional format. This dynamic nature of online education stems from the multiple choices in mode of teaching/ learning, tools, platforms etc which are constantly evolving due to changing application of technology.

            2. Extensive use of technology in the online course design is not only a core requirement for a class to be dynamic but can also leverage this aspect. For example, faculty can use a multimedia page to present the course contents with resources. This is vastly more efficient compared to the traditional method of handing out notes which allow for little to no real time revision to content.
            
            3. Other ways in which technology can be used to augment the learning dynamics is through Break outs and Debriefs.
            
            A break out is the online equivalent of making groups in class for topic/course related discussion. Depending on the platform, groups for breakouts can be randomly/manually assigned for a specific short duration lasting between 5-10 minutes. Breakouts have been found to be more effective since students are more aware of the time dedicated for discussion and have to remain focus on the discussion rather than losing course like in the traditional format. Debrief is a reflective activity that helps to summarise the course content either at the beginning or end of class provided by the faculty. Debrief entails providing students a high-level overview of the learning outcomes or what they have learnt at the end of the class. This allows students to be able to apply their learnings and process information better.
            
            Debriefs come strictly at the start or end of class and should always be a part of the lesson plan. One of the best practises with regards debrief is that, it may be fine to shorten the actual teaching time but to not skip on debriefing.
            
            4. Here is a question for you:
            
            What are the other ways in which the online classroom can become more dynamic?
            
            These may or may not be related to technological tools.`,
          },
          {
            name: "Assignment 6",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 48 min",
      },
      {
        name: "Session 7: Nurturing and managing debates",
        subContent: [
          {
            name: "Session by Dr. Michael Shiel, March 26th 2021",
            id: "1",
            length: "43:53",
            lessonUrl: "https://youtu.be/Uol4kkZbJQk",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1617721235642-1616732434931-Topic%207-%20How%20to%20go%20deep-%20Nurturing%20and%20managing%20debates%20-%20Brief-%20March%2026%202021.pdf?alt=media&token=e356ffe9-e7d2-4185-bbf8-91ec06fd42d9",
                id: 1,
                type: "application/pdf",
              },
              {
                title: "Presentation Slides",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1617721368041-1617720875618-Session%207%20-%20How%20to%20go%20deep-%20Nurturing%20and%20managing%20debates-%20PPT-%20March%2026%202021.pptx?alt=media&token=64f32a8f-e237-4597-a3c0-391eade43a2e",
                id: 2,
                type: "application/pptx",
              },
              {
                title: "Graphic Illustration 1",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1617721258268-1617720944737-Illustration%201.jpg?alt=media&token=14511951-31b9-4fda-9ccb-d56fdef6fa08",
                id: 3,
                type: "image/jpeg",
              },
              {
                title: "Graphic Illustration 2",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1617721279942-1617720908438-Illustration%202.jpg?alt=media&token=e9d71a50-9780-44b6-bc7c-7bf20d7fcb8e",
                id: 4,
                type: "image/jpeg",
              },
            ],
            details: `1.In the traditional format of teaching, being able to interact in-person helps to build social connections faster than in the online environment. Faculty also agree that it is easier to manage conflict, class dynamics with regards discussions and debates while maintaining a healthy learning environment. The absence of physical cues makes this more burdensome in the online format. In fact, the nature of online communication is such that some messages may have an unintended adverse impact. Could there be a simple way of nurturing and managing debates in the online environment?

            2. Debates and discussion in the online format are generally carried out verbally or through written posts/discussions. With this in mind, it will be useful to set ground rules for communication through a ‘guidelines for communication’ document and which can be shared at the beginning of the class. The focal point of this document should be to guide students on how to carry out meaningful and respectful communication while meeting course learning goals. Example, stating minimum and maximum number of written posts per week, per student conveys clear expectations in terms of contribution to discussion.
            
            3. A crucial aspect of being able to nurture and manage debates is clarifying the role the faculty is playing- is it of a moderator or a participant? While faculty are free to become participants, discussion benefits more when the faculty is a moderator and can provide constructive, corrective feedback. Additionally, by being a moderator, faculty can ensure that every student in class participates equally and can track participation through learning management systems.
            
            4. As understood, the challenge of managing debates in the online environment setting is that this is a time-consuming endeavour for faculty. One practical way to overcome this is by engaging student more among themselves. For example, faculty should encourage students to respond to the questions or queries put forth by their classmates. Later faculty can add important points that may have been missed out. This saves time and
            
            5. Here is a question for you:
            
            What kind of challenges have you faced while moderating online discussions? Has this adversely influenced the online environment?`,
          },
          {
            name: "Assignment 7",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 44 min",
      },
      {
        name: "Session 8: How do you become the “best self” on stage?",
        subContent: [
          {
            name: "Session by Dr. Timea Havar-Simonovich, April 2nd 2021",
            id: "1",
            length: "44:43",
            lessonUrl: "https://youtu.be/USmMblRB7Jw",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1617721759466-1617289568381-Topic%208-%20How%20do%20you%20become%20the%20best%20self%20on%20stage-%20Brief-%20April%202nd%202021.pdf?alt=media&token=89e60d36-1183-450b-a672-272a2fa0e200",
                id: 1,
                type: "application/pdf",
              },
              // {
              //   title: "Presentation Slides",
              //   url: "https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975547925-1613527179471-Session%203-Storytelling%20in%20Online%20Education-Ppt-Feb%2012%202021.pdf?alt=media&token=134a0e50-88cf-4af9-88cc-859e55b9270e",
              //   id: 2,
              //   type: "application/pptx",
              // },
              // {
              //   title: "Graphic Illustration 1",
              //   url: "https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975902886-1613738614139-Graphic%20Illustration%201.jpeg?alt=media&token=64346094-8a91-4c17-8e5e-0b6e0a8373aa",
              //   id: 3,
              //   type: "image/jpeg",
              // },
              // {
              //   title: "Graphic Illustration 2",
              //   url: "https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975925378-1613738623940-Graphic%20Illustration%202.jpeg?alt=media&token=8fad0a22-ac9c-43a9-8025-d9c7d4187e75",
              //   id: 4,
              //   type: "image/jpeg",
              // },
            ],
            details: `1. Through session 1 to 7 we have discussed various drivers and aspects of online education namely challenges in online teaching, use of technology and storytelling in enhancing the online environment, importance of icebreakers, debrief and breakouts etc. Now we turn our attention to what faculty can do to physically and mentally prepare themselves in a way that the teaching tools are effective and serve the intended purpose.

            2. For most faculty, online teaching is a new way of teaching and can be quite stressful especially since it is difficult to assess how well the students are understanding the content. It is best to try and overcome such anxiety before class through certain activities. For example, release your nervous energy by engaging in any physical activity of your choice for 10 minutes and before the class begins. Rehearse the important points that need to be covered in class. Prepare notes and keep these at hand in case you lose track of the amount of/sequence in content covered.
            
            3. Another good tactic to eliminate teaching anxiety is by using model communication practices. For example, it is useful to identify whether you are more comfortable using presentation slides or drawing on the whiteboard to teach. Is it important for you to actually see your students on screen? Have a general set of guidelines rather than having a fixed way of teaching a class. This will also prepare you for the worst-case scenario.
            
            4. Faculty should be well-versed with the tools to be used in teaching synchronously and asynchronously. It is essential to understand the features of the platform in use. Example, being able to find/enable the breakout room feature on the platform (Zoom/Microsoft Teams) is critical to engaging students in group discussions. As technology evolves to improve the online teaching/learning experience, faculty need to keep pace with the updated tools/resources.
            
            5. Online classes tend to be timed to the hour and this makes time management even more important. Faculty should set up an agenda for each class and assign a set amount of time to interact with students. In absence of an agenda, online classes can turn into one-on-one interactions with students. Simultaneously, faculty need to apply tips to create a learning environment which is safe and welcoming.
            
            6. Here is a question for you:
            
            What are the 2-3 techniques that you generally use to physically/mentally prepare yourself before the class? Have these been useful in addressing larger and smaller class alike?`,
          },
          {
            name: "Assignment 8",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 45 min",
      },
      {
        name: "Session 9: How do learners become their “best self”?",
        subContent: [
          {
            name: "Session by Sabine Henrichfreise, April 9th 2021",
            id: "1",
            length: "46:49",
            lessonUrl: "https://youtu.be/UbyE797J_-Q",
            documents: [
              {
                title: "Topic Brief",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1618897133391-1617884841824-Topic%209-How%20do%20learners%20become%20their%20best%20self-%20Brief-%20April%209%202021.pdf?alt=media&token=bf718f46-a994-4392-b695-c6fd0fd51b59",
                id: 1,
                type: "application/pdf",
              },
              // {
              //   title: "Presentation Slides",
              //   url: "https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975547925-1613527179471-Session%203-Storytelling%20in%20Online%20Education-Ppt-Feb%2012%202021.pdf?alt=media&token=134a0e50-88cf-4af9-88cc-859e55b9270e",
              //   id: 2,
              //   type: "application/pptx",
              // },
              {
                title: "Graphic Illustration",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1619013613788-1619013584559-Graphic%20Illustration.jpeg?alt=media&token=be587aae-c2e7-4cf8-a6f6-230bd387e1b5",
                id: 3,
                type: "image/jpeg",
              },
            ],
            details: `1. As we move towards the end of this Online Teachers’ Training seminar, let us recapitulate some of the important highlights of this seminar that focus on the students, i.e the audience. While the obvious question regarding online teaching has been: ‘How do I engage with my students more effectively? the less obvious and equally important ones are: ‘How do I keep my students motivated to learn while they continue to be socially isolated?’ ‘How can coursework be customized to different learning styles?’ ‘What is the best mode of teaching: synchronous or asynchronous?’.

            While answering the questions above and more, it is essential to remember that online teaching has to be dynamic, easy and fun. Irrespective of the mode of teaching, there are some tips that faculty can share with students to help them succeed in class. The first is, students need to treat an online class like a regular inperson class. Encourage students to be as disciplined as they would be while attending an in-person class. For example, ask students to create a weekly schedule to stay organized and follow the schedule for class readings, assignments.
            
            As learnt earlier, there are primarily 4 different learning styles: Activist, Theorist, Pragmatist, Reflector. Faculty can provide students with resources that help them understand the type of learner they are, and the best way for them to learn in class. If students learn well in groups, encourage them to form their own network outside of class which will ensure active learning through learning discussions too.
            
            Students should use technological tools effectively. For example, students should use the option for office hours online just as they would in-person. This helps them to connect with faculty and discuss any important issues that could be an impediment in their learning journey. Also, students should use audio/video in class- this helps students to be more accountable in attending classes and helps them to focus better in class. Further, students should avoid use of other 2 technological tools such as mobile, video games etc during class which leads to excessive multitasking and distraction in learning.
            
            Encourage students to pay attention to their personal well-being too. Frequent breaks between classes, solving assignments etc reduces chances of burn out and onset of boredom which are common in online classes. Students should connect with friends online or as per safety norms, exercise and try to have a regular routine to maintain a healthy social-emotional connection.
            
            6. Here is a question for you: Ask your students what are the 2-3 learning practises that they have found useful in the past year/since the beginning of the online classes?`,
          },
          {
            name: "Assignment 9",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 49 min",
      },
      {
        name: "SSession 10: The Best of Online Teachers' Training Series",
        subContent: [
          {
            name: "Session by Dr. Christian Rauch, April 19th 2021",
            id: "1",
            length: "44:18",
            lessonUrl: "https://youtu.be/IwklS7n-ezc",
            documents: [
              {
                title: "Summary of Sessions 1-9",
                url:
                  "https://firebasestorage.googleapis.com/v0/b/igesia-94de2.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1618989675425-1611759190667-Summary%20of%20Sessions%201-9.docx?alt=media&token=0980a469-dbd8-4131-97b0-ec70cae73864",
                id: 1,
                type: "application/docx",
              },
              // {
              //   title: "Presentation Slides",
              //   url: "https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/drive%2FNVuGhdsP2BOpIxciHpF0l0YTmVh2%2F1613975547925-1613527179471-Session%203-Storytelling%20in%20Online%20Education-Ppt-Feb%2012%202021.pdf?alt=media&token=134a0e50-88cf-4af9-88cc-859e55b9270e",
              //   id: 2,
              //   type: "application/pptx",
              // },
            ],
            details: `Topic 1: Changes for the teacher & How do people learn online? This topic will discuss challenges that teachers have faced in the past year with regards online teaching and the problems that continue to recur. Some such as operational pitfalls are common in online classrooms across the globe. Given this, there are corresponding opportunities to correct this and even to experiment with online teaching styles.

            Topic 2: The Field of Learning Tech Here we talk about the technology (tools, platforms etc) that is being used in online teaching. We will discuss how technology can be leveraged to redesign classroom dynamics. Further, participants will learn about how technology can be effectively used in all elements of online teaching- design, development, application and evaluation.
            
            Topic 3: Creating a storyboard for your journey Storytelling is an important tool in online teaching and it is essential to understand how to create a powerful story. For this, we will focus on the elements of a good story and the supporting material for the same.
            
            Topic 4: Planning for the cognitive side of things Creating a socio-emotional connection with students is important in online teaching especially since this is amiss due to a lack of in-person interaction. Not only is a socio-emotional connection required to build the online community but also helps students to remain motivated in class.
            
            Topic 5: Icebreakers and more Everyone who has been engaged in online teaching will know that icebreakers in class are necessary. However, these often end up being awkward and ineffective due to various reasons. Here we will learn about designing icebreakers keeping various parameters of the class in mind.
            
            Topic 6: Break-Outs, Report-Outs and Debriefs Most online teaching faculty will agree that managing time in this format is far more efficient than the in-person classes. To that end, it is important to carefully schedule break out sessions that focus on collaborative reporting and course debrief by students.
            
            Topic 7: Nurturing and managing debates Managing debates and encouraging a healthy debate environment can be tricky in an online setting. As most of the interaction occurs through platforms and in virtual environment, it is important to retain some aspects of an in-person debate.
            
            Topic 8: How do you become the “best self” on stage? Some faculty who are adept at teaching classes in-person have struggled with the online format. Being comfortable in the online format not only helps one to be more self-assured but also helps in energizing students about the course. Here we will learn about challenges, failures faculty have experienced in converting the in-person class to the online format and how to overcome these.
            
            Topic 9: How do the learners become their “best self”? A critical aspect of being successful at online teaching is being able to adapt to the varied learning styles. Faculty need to experiment and design their coursework in a manner that dynamically evolves to suit the needs of the students.
            
            Topic 10: The best of ITS! The last class will teach you about organizing a virtual party. This is helpful in creating opportunities for social interaction between students and faculty.`,
          },
          {
            name: "Assignment 10",
            question: "What will be the impact on classrooms after pandemic?",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "92121",
        details: "1 lecture - 45 min",
      },
    ],
    isCourse: true,
  },
];

export const myCourseList = [
  {
    id: "1",
    name: "Innovation Management: Strategy and Execution",
    description:
      "Innovation has become critical for winning in the marketplace. Several forces of change including technological progress, demographic shifts, changing customer demands and global competition have increased the need for companies to excel in innovation. ",
    image:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Finnovation-management-strategy-and-execution.jpg?alt=media&token=9ef98967-c7bd-4f67-8d64-048225b069a5",

    fee: "₹95,000",
    feeValue: 95000,
    date: "30 October, 2021",
    courseFeatures: [
      "Creativity and ideation",
      "Innovation readiness",
      "Innovation leadership",
    ],
    courseRequirements: [
      "A device with active internet connection",
      "High school maths",
    ],
    providers: [
      {
        name: "Professor Soumitra Dutta",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Soumitra%20Dutta.jpg?alt=media&token=9c560b2f-7c85-4462-b2cc-2faa00633799",
        designation: "Cornell University",
        id: "1",
        username: "soumitra",
        email: "soumitra@igesia.co",
        address: "New York",
        description:
          "Soumitra Dutta is a Professor of Management at and the former founding dean of the SC Johnson College of Business at Cornell University, New York. He is the founder of the Global Innovation Index, published by the World Intellectual Property Organization and was the co-editor of the Global Information Technology Report, published by the World Economic Forum – two influential reports in technology and innovation policy. He is also the founder and President of Portulans Institute, a non-partisan nonprofit research and education institution based in Washington DC.",
      },
      // {
      //   name: 'Dr. Dongmin Chen',
      //   avatar:
      //     'https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FDr.%20Dongmin%20Chen.jpg?alt=media&token=ccd8be2b-8ca0-4a39-a4d3-2e31a905faff',
      //   designation: 'Peking University',
      //   id: '2',
      //   username: 'dongmin_chen',
      //   email: 'dongmin@gmail.com',
      //   address: 'United States',
      // },
      // {
      //   name: 'Professor Tawfik Jelassi',
      //   avatar: 'https://igesia.co/assets/jelasi.jpg',
      //   designation: 'IMD',
      //   id: '3',
      //   username: 'tafik',
      //   email: 'tafik@gmail.com',
      //   address: 'United States',
      // },
      {
        name: "Professor Bruno Lanvin",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/faculty%2FProfessor%20Bruno%20Lanvin.jpg?alt=media&token=ca7673d5-6e39-4b78-9620-056deaae5a3a",
        designation: "President, Smart City Observatory",
        id: "4",
        username: "bruna_lanvin",
        email: "bruno@gmail.com",
        address: "United States",
        description:
          "Dr Bruno Lanvin is the President of the Smart City Observatory. He is also Executive Director of INSEAD’s Global Indices, founder and CEO of D&L Partners, and co-founder and director of Portulans Institute. He has exercised senior responsibilities at the World Bank and in the United Nations.",
      },
    ],

    notificationList: [
      {
        message: "Instructor shared a document LectureNote101.pdf",
      },
      { message: "Instructor shared a document LectureNote54.ppt" },
      { message: "Instructor started a Live Session" },
      { message: "Instructor updated the course description" },
    ],

    peopleList: [
      {
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
        username: "lim",
      },
      {
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
        username: "shayat",
      },
      {
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
        username: "siddhesh",
      },
      {
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
        username: "richard",
      },
      {
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
        username: "sathvik",
      },
    ],
    courseContent: [
      {
        name: "Creativity and ideation",
        subContent: [
          {
            name: "Course introduction",
            id: "1",
            length: "6:59",
            documents: [
              {
                title: "Introduction.pdf",
                url: "http://www.africau.edu/images/default/sample.pdf",
                id: "313",
              },
            ],
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",

            details:
              "The program will describe approaches to enhancing creativity and the process of ideating new products and services. Approaches such as design thinking and Blue Ocean strategy will be highlighted as approaches to enhancing creativity and coming up with new products and service ideas",
          },
          {
            name: "AI Basics quiz",
            id: "1234234",
            isQuiz: true,
          },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [],
            details:
              "The program will describe approaches to enhancing creativity and the process of ideating new products and services. Approaches such as design thinking and Blue Ocean strategy will be highlighted as approaches to enhancing creativity and coming up with new products and service ideas",
          },
          {
            name: "AI Assignment 1",
            id: "879713",
            isAssignment: true,
          },
        ],
        id: "1111",
        details: "2 lectures - 36 min",
      },
      {
        name: "Innovation readiness",
        subContent: [
          {
            name: "Course introduction",
            id: "1",
            length: "6:59",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [
              {
                title: "Introduction.pdf",
                url: "http://www.africau.edu/images/default/sample.pdf",
                id: "313",
              },
            ],
            details:
              "Companies have to work on multiple dimensions to enhance their innovation readiness. Investments in human talent have to be complemented by new processes and appropriate technologies",
          },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [],
            details:
              "Companies have to work on multiple dimensions to enhance their innovation readiness. Investments in human talent have to be complemented by new processes and appropriate technologies",
          },
        ],
        id: "92121",
        details: "2 lectures - 36 min",
      },
      {
        name: "Innovation leadership",
        subContent: [
          {
            name: "Course introduction",
            id: "1",
            length: "6:59",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [
              {
                title: "Introduction.pdf",
                url: "http://www.africau.edu/images/default/sample.pdf",
                id: "313",
              },
            ],
            details:
              "Rigorous and disciplined execution is essential for innovation leadership. The program will outline the key essentials of managing the innovation process and also describe strategies adopted by different firms to drive innovation such as the creation of innovation labs and corporate ventures",
          },
          {
            name: `What you're going to get from this course?`,
            id: "2",
            length: "LIVE 30:00",
            lessonUrl:
              "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_480_1_5MG.mp4",
            documents: [],
            details:
              "Rigorous and disciplined execution is essential for innovation leadership. The program will outline the key essentials of managing the innovation process and also describe strategies adopted by different firms to drive innovation such as the creation of innovation labs and corporate ventures",
          },
        ],
        id: "2121",
        details: "2 lectures - 36 min",
      },
    ],
    isCourse: true,
    isEnrolled: true,
  },
];

export const projectList = [
  {
    id: "1",
    name: "Eat Fit: Healthy Food Project",
    slug: "eat-fit",
    description:
      "Eat Fit Project’s mission is to create a thoughtful and productive community of youth and adults from diverse backgrounds who work together to build a sustainable food system. Our community produces healthy food for residents of the city and suburbs, provides youth leadership opportunities, and inspires and supports others to create change in their own communities. We envision a world where youth are active leaders, diverse communities feel connected to the land and each other, and everyone has access to fresh, local, healthy, affordable food.",
    image:
      "https://png.pngtree.com/thumb_back/fw800/back_our/20190620/ourmid/pngtree-blue-chalkboard-simple-food-cover-rice-cooker-e-commerce-banner-image_172736.jpg",

    notificationList: [
      {
        message: "Admin shared a document ProjectNotes101.pdf",
      },
      { message: "Admin shared a document ProjectNotes54.ppt" },
      { message: "Admin started a Live Session" },
      { message: "Admin updated the project description" },
    ],

    peopleList: [
      {
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
        username: "lim",
      },
      {
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
        username: "shayat",
      },
      {
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
        username: "siddhesh",
      },
      {
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
        username: "richard",
      },
      {
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
        username: "sathvik",
      },
    ],
    chatList: [
      {
        content: "How are you?",
        user: {
          displayName: "Siddhesh Pawar",
          avatar:
            "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
          email: "siddhesh@gmail.com",
          uid: "1423234asd3211",
        },
        timestamp: Date.now(),
        uid: "11243231",
      },
      {
        content: "Hello",
        user: {
          displayName: "Siddhesh Pawar",
          avatar:
            "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
          email: "siddhesh@gmail.com",
          uid: "1423234asd3211",
        },
        timestamp: Date.now(),
        uid: "asd332",
      },
    ],

    isProject: true,
  },
  {
    id: "2",
    name: "Project C",
    slug: "project-C",
    description: `The focus of this project is put on creating a clear and correct understanding of the project in minds of the people and organizations involved in the planning and development process. The project team (which is supposed to do the project) uses the document to get a general idea of what amount of work and under what requirements is planned for completion. The senior management team regards the project description as the key source of preliminary information necessary for strategic planning and development.

      I need to note that some people are confused with the terms “project description” and “project background“. They might regard both terms as equivalent. But the terms are not same and they have different meaning. Earlier, in one of our publications we briefly talked about the project background and how it differs from the project description. Please read more here. I also recommend the service at www.domyassignment.com specializing in delivering plagiarism-free ‘do my assignments‘ orders to students worldwide.`,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQWy_pInbN7RQIrtmO-BN8pHw9cHvS1zdoCem81tsei8w8VlsPCEDLaWQ6pSSnWs2cIXPM&usqp=CAU",

    notificationList: [
      {
        message: "Admin shared a document ProjectNotes101.pdf",
      },
      { message: "Admin shared a document ProjectNotes54.ppt" },
      { message: "Admin started a Live Session" },
      { message: "Admin updated the project description" },
    ],

    peopleList: [
      {
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
      },
      {
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
      },
      {
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
      },
      {
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
      },
      {
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
      },
      {
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
      },
      {
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
      },
      {
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
      },
      {
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
      },
      {
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
      },
      {
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
      },
    ],

    chatList: [
      {
        content: "How are you?",
        user: {
          displayName: "Siddhesh Pawar",
          avatar:
            "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
          email: "siddhesh@gmail.com",
          uid: "1423234asd3211",
        },
        timestamp: Date.now(),
        uid: "11243231",
      },
      {
        content: "Hello",
        user: {
          displayName: "Siddhesh Pawar",
          avatar:
            "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
          email: "siddhesh@gmail.com",
          uid: "1423234asd3211",
        },
        timestamp: Date.now(),
        uid: "asd332",
      },
      {
        content: "Hello",
        user: {
          displayName: "Siddhesh Pawar",
          avatar:
            "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
          email: "siddhesh@gmail.com",
          uid: "1423234asd3211",
        },
        timestamp: Date.now(),
        uid: "asd332",
      },
      {
        content: "Hello",
        user: {
          displayName: "Siddhesh Pawar",
          avatar:
            "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
          email: "siddhesh@gmail.com",
          uid: "1423234asd3211",
        },
        timestamp: Date.now(),
        uid: "asd332",
      },
    ],

    isProject: true,
  },
];

export const myProjectList = [
  {
    id: "1",
    name: "Eat Fit: Healthy Food Project",
    description:
      "Eat Fit Project’s mission is to create a thoughtful and productive community of youth and adults from diverse backgrounds who work together to build a sustainable food system. Our community produces healthy food for residents of the city and suburbs, provides youth leadership opportunities, and inspires and supports others to create change in their own communities. We envision a world where youth are active leaders, diverse communities feel connected to the land and each other, and everyone has access to fresh, local, healthy, affordable food.",
    image:
      "https://png.pngtree.com/thumb_back/fw800/back_our/20190620/ourmid/pngtree-blue-chalkboard-simple-food-cover-rice-cooker-e-commerce-banner-image_172736.jpg",

    notificationList: [
      {
        message: "Admin shared a document ProjectNotes101.pdf",
      },
      { message: "Admin shared a document ProjectNotes54.ppt" },
      { message: "Admin started a Live Session" },
      { message: "Admin updated the project description" },
    ],

    peopleList: [
      {
        name: "Lim Yong kang",
        avatar:
          "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
        email: "lim@gmail.com",
        username: "lim",
      },
      {
        name: "S Hayat",
        avatar:
          "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
        email: "shayat@gmail.com",
        username: "shayat",
      },
      {
        name: "Siddhesh Pawar",
        avatar:
          "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
        email: "siddhesh@gmail.com",
        username: "siddhesh",
      },
      {
        name: "Richard Moon",
        avatar:
          "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
        email: "richard@gmail.com",
        username: "richard",
      },
      {
        name: "Sathvik Saya",
        avatar:
          "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
        email: "sathvik@gmail.com",
        username: "sathvik",
      },
    ],
    chatList: [
      {
        content: "How are you?",
        user: {
          displayName: "Siddhesh Pawar",
          avatar:
            "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
          email: "siddhesh@gmail.com",
          uid: "1423234asd3211",
        },
        timestamp: Date.now(),
        uid: "11243231",
      },
      {
        content: "Hello",
        user: {
          displayName: "Siddhesh Pawar",
          avatar:
            "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
          email: "siddhesh@gmail.com",
          uid: "1423234asd3211",
        },
        timestamp: Date.now(),
        uid: "asd332",
      },
    ],

    isProject: true,
    isEnrolled: true,
  },
];

export const blogList = [
  {
    id: "1",
    name: "Setting up your home studio for podcasting or creating video course",
    description: `If you are looking to record for an online course or podcast, here’s a simple home studio setup for two levels — “absolute beginner” and “semi professional”.
      
But before you dive in and order all the suggested gear, let me warn you
Content quality is more important than gear.
Also, there may be better/expensive or cheaper alternatives to gears I suggest below. Most importantly, beyond a point, pumping more money won’t help, it will only make your life more difficult because you would need staff to help you out in operating and editing.
Also note, audio is more important than video. It is also more complex and difficult.

Level 1: Absolute Beginner
If you are just starting out and want an experience with little or no investment, you can with the bare minimum essentials -

OBS Studio — this will give you the ability to use multiple audio and video inputs like multiple cameras, presentation, recorded video etc. If you want a video with your presentation on the top right corner (or similar) like you see in tutorials, you can add layers in OBS studio.

iPhone as camera — download OBS camera app on iphone. There are similar apps for android. You can get multiple camera angles with multiple phones and plug them as inputs in OBS Studio.

A USB mic — emphasis on USB, most high quality mics come with XLR output for which you need an audio interface.

Ensure good lighting and a quiet surroundings

This setup may be absolutely fine for your regular online class or hobby podcasting but you will soon realise for a professional touch, you will need multiple camera angles and crystal clear audio.

Level 2: Semi Professional

If you are looking for a more professional setup or want to record with a music instrument, you can introduce more complexities for your audio and video recording devices. But remember, invest in these gradually, more gear means more management time. Invest in these gear only after you have some experience with recording.
If you looking for an investment plan, follow this order
For recordings with no musical instruments

Mic > Lights > Camera > Video interface
For recordings with musical instruments

Mic > Audio interface > Mounts and Stands > Lights > Camera > Video Interface > Mounts and Stands

1. Audio
Mic (Audio Technica AT 2020) — USB output for regular users, XLR output for musicians and if you have an audio interface
Audio interface (Focusrite Scarlett 4i4) — Only needed if you are a musician or want multiple audio devices
Cables (XLR cable, Instrument Cable for musical instrument)
Mounts and Stands — Check for mic holders on amazon. This depends on your setup. Mounts and stands keep your workspace neat and absolute necessary for mics otherwise they pick up noise.

2. Video
Camera (Phone/ DSLR with clean output/ GoPro/ Mirrorless camera, webcam)
Video interface (Blackmagic Atem mini)
Cables (output to HDMI, input can vary according to the camera)
Mounts and stands — depends on your choice and camera. Cheap tripods tend to wobble. Heavier ones occupy space.
Lighting (Ring lights)

3. Recording/ Streaming software
Video (OBS Studio)
Audio (optional — in case using effects, there are pro softwares available that can be used as audio input in OBS)


      `,
    image: "https://miro.medium.com/max/12644/1*o07o88encF48B60mJCQ8rA.jpeg",

    date: "3 September, 2021",

    isBlog: true,
    slug: "setting-up-your-home-studio",
    author: {
      name: "Arani Chaudhuri",
      picture:
        "https://miro.medium.com/fit/c/262/262/1*G1R8WjbaLsfuMvGdHeuLvQ.png",
      designation:
        "Entrepreneurship. Technology. Leadership. Artificial Intelligence. Travel. Founder & CEO @ iarani Inc.",
    },
  },
  {
    id: "2",
    name: "Globalisation 4.0 — Are you ready?",
    description: `The new wave of globalisation is for everyone; not just the elite.

As the world’s most powerful people converge at Davos for the World Economic Forum’s Annual Meeting to discuss Shaping Globalisation 4.0, the question on the minds of the not-so-elite is — “Is this another plan to make the rich richer?”
    
Let’s start by answering the basic question — What is globalisation?
Is it the ability to access products and services from around the world without any problem?
Is it defined by the ease with which once can transcend geographical borders and travel the world?
Is multicultural sensitivity a parameter to gauge the degree of globalisation?
Is technology imperative for successful global collaboration?
To understand Globalisation 4.0, let’s start at the very beginning when the world was still a vast and mysterious place. The idea of exploring new territories was perhaps an unfathomable one and, as a result, trade was restricted to local and regional markets. As time passed and people became more and more curious and industrious, they began venturing into what were once unchartered regions. The Silk Route was discovered, and quickly after yarns of the beautiful material began adorning the lives of those in the West [1]. The first seeds of globalisation were sown, and the rest is history. While, traders got a taste of reducing the world to a place with more access and less intimidation; consumers got hooked to the exotic products that were now well within their reach.
From then on wave after wave of industrial reforms have washed over our world. For a concept that tackles things on a worldly scale; it sure feels like globalisation is shrinking the world.


What Is Globalisation 4.0?

Fuelled by the advancements in digital technology, we are headed towards another phase of shrinking the world. What sets this shrinkage apart from its predecessors is the fact that it dawns at a time when the sentiment is not in favour of global collaboration. Political narratives espouse protecting nationalistic interests by keeping immigrants at bay, discouraging international trade, and harbouring resentment towards anything and anyone foreign. While such commentary has become increasingly common especially in developed countries, it hasn’t been enough to affect the rate at which digital technology has evolved.
The way we do business today is rapidly morphing into a completely different beast that has to be tamed well in time to avoid utter chaos. It is essential to keep the following things in mind if one wishes to stay in the game and flourish:

Make Technological Renovation One Of Your Primary Goals — Achieving excellence is next to impossible if one is averse to adopting technological advancements that boost efficiency and make collaboration easier. Besides, investing in tools that churn reams of business data and derive rich insights is vital to make better decisions and help you sidestep the same mistakes in the future. Embracing technology is, therefore, the most critical aspect to ascertain success.

Train Future Leaders Well — With Globalisation 4.0 swiftly changing the way we do things, there is a high demand for leaders who can handle fluidity and change without as much as a frown in their brow. It is crucial to develop many such leaders who can manage change well and who possess analytical thinking skills so that businesses do not come tumbling down when digital disruption hits them smack in the face.

Re-skill Employees In Time To Avoid Depleting Human Capital— Regular and frequent technological innovations make it all the more important for employees to be trained and re-trained quickly. This re-training helps them stay ahead of the curve. Fine tuning existing skills and gaining new skills are both equally significant when it comes to ensuring that your employees can do their job well and are also immune to effects of job polarisation and displacement.

Do Not Ignore Cyber Security — Along with IoT, which is one of the leading technologies driving phase 4 of globalisation, comes the threat of cybercrime. If you too are riding the wave of Globalisation 4.0 like many other far-sighted organisations, then it is important for you to take appropriate steps to protect you and your customers from cyber-attacks of all kinds.

Protect The Planet From Becoming Uninhabitable — According to Julia Luscombe, Director of Strategic Initiatives, Feeding America [2], climate change is a serious issue that could mar the overall success of Globalisation 4.0. It is a problem that could skew the impact of this historical economic overhaul by negatively affecting both vulnerable territories and people much more than others. Resources needed to bolster weaker economies and promote education will instead be channelled towards repairing the fallouts of climate change. So, while we still have the time, taking steps to reverse global warming is a responsibility that every individual should shoulder.
An important takeaway from all the above is that riding the wave of Globalisation 4.0 is not just limited to experienced surfers with deep pockets, it is accessible to all.
Globalisation 4.0 will provide unfettered access to markets riding on technological advancements that will trump insecurities and leave no wall high enough for the spirited. It will weave many success stories from developing and developed economies alike bridging the gap. However, success will come to only those who are prepared and ready for the big wave with the potential of drowning big ships without a crow’s nest.
At iarani, we are well prepared for this new wave and are already helping businesses adjust to the new ways of doing business. Using technology to increase effectiveness and efficiency is our favourite cup of work, and we actively look for opportunities to use technology to make our lives and those of our clients more productive.
We are actively partnering with organisations to fuel their digital transformation initiatives. I will write more about our initiatives in education, climate change, economic development of the Himalayan region, artificial intelligence and culture.
We are always interested in innovative ideas and collaborations. Do reach out if you have something interesting in mind.

`,
    image: "https://miro.medium.com/max/10944/1*khp2EkiRbUsJ3hIT5tWDiw.jpeg",

    date: "3 September, 2021",

    isBlog: true,
    slug: "globalisation-4.0",
    author: {
      name: "Arani Chaudhuri",
      picture:
        "https://miro.medium.com/fit/c/262/262/1*G1R8WjbaLsfuMvGdHeuLvQ.png",
      designation:
        "Entrepreneurship. Technology. Leadership. Artificial Intelligence. Travel. Founder & CEO @ iarani Inc.",
    },
  },
];

export const timelineData = [
  {
    user: {
      name: "Arani Chaudhuri",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQH35hhMsvi-yw/profile-displayphoto-shrink_800_800/0/1516789002967?e=1628121600&v=beta&t=WZ3-TiCDNcZL1tl9HeWv7g12dhKavevBD3R5696ASbw",
      designation: "CEO, Igesia",
    },
    timestamp: Date.now(),
    content:
      "Leading Academic Instituions in Turbulent Times course commenced on 20th March 2021 in association with Confederation of Indian Industry.",
    id: "1",
    url: null,
    type: 20,

    photoURL: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/academy-update-1.png",
  },
  // {
  //   id: '3',

  //   name: 'Blue Ocean Awards: 7th Edition',
  //   description:
  //     '7th edition turns international in 2021 on the 11th of May, simultaneously at HEC Paris, Bordeaux Technowest, Sciences-U EFAB in Lyon and the French Embassy of South Africa in Pretoria',
  //   image:
  //     'https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/apps%2Fmobile%2FBOA.png?alt=media&token=6515c6d4-4aa3-4ec5-b527-e1ed29cff9a3',
  //   date: '11 May, 2021',
  //   isEvent: true,
  //   type: 21,
  // },
  {
    user: {
      name: "Jatin Ahuja",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4E03AQEHl9sSuZ4Dnw/profile-displayphoto-shrink_800_800/0/1518427542376?e=1628121600&v=beta&t=21GGpnvwN_lSvn0H3kdmGf8Lk9I7T5CbO1vxc7rkrv4",
      designation: "Tech Lead, Igesia",
    },
    timestamp: Date.now(),
    content:
      "Preview links before and after sharing links in igesia. Link previews are available in the message timeline and igesia drive app on both mobile and web.",
    id: "14324",
    url: null,
    type: 20,

    photoURL: "https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/message-link.png",
  },
];

export const projectTimeline = [
  {
    user: {
      name: "Rob fennie",
      avatar:
        "https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F9%2F2019%2F03%2Ftop-chef-adrienne-wright-FT-BLOG0119.jpg",
      designation: "Admin",
      email: "rob@gmail.com",
      username: "rob",
    },
    timestamp: Date.now(),
    content: `Together we covered a broad range of relevant food&design topics - from autonomous kefir machines to urbanised agriculture, from gene modification technology to augmented reality supermarkets and from future farming to surreal sausages. We can’t wait to see what’s next!`,
    id: "1",
    url: null,
    type: 20,

    photoURL:
      "https://thedifd.com/wp-content/uploads/2018/08/5-Carolien-Niebling-The-Future-Sausage-878x1024.jpg",
  },
  // {
  //   id: '3',

  //   name: 'Blue Ocean Awards: 7th Edition',
  //   description:
  //     '7th edition turns international in 2021 on the 11th of May, simultaneously at HEC Paris, Bordeaux Technowest, Sciences-U EFAB in Lyon and the French Embassy of South Africa in Pretoria',
  //   image:
  //     'https://firebasestorage.googleapis.com/v0/b/igesia-v1.appspot.com/o/apps%2Fmobile%2FBOA.png?alt=media&token=6515c6d4-4aa3-4ec5-b527-e1ed29cff9a3',
  //   date: '11 May, 2021',
  //   isEvent: true,
  //   type: 21,
  // },
  {
    user: {
      name: "Jeremy Ford",
      avatar:
        "https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F9%2F2019%2F03%2Ftop-chef-s16e15-eric-adjepong-FT-BLOG0319.jpg",
      designation: "Moderator",
      email: "jeremy@gmail.com",
      username: "jeremy",
    },
    timestamp: Date.now(),
    content:
      "Does green apple juice taste the same as red apple juice? That might seem like a silly question. Food coloring does not have any flavor—so how could it change how something tastes? Find out whether it does in this food project!",
    id: "14324",
    url: null,
    type: 20,

    photoURL:
      "https://cdn.sciencebuddies.org/Files/13102/7/color-taste-test-summary.jpg",
  },
];

export const memberList = [
  {
    name: "Lim Yong kang",
    avatar:
      "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
    email: "lim@gmail.com",
    username: "lim",
  },
  {
    name: "S Hayat",
    avatar:
      "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
    email: "shayat@gmail.com",
    username: "shayat",
  },
  {
    name: "Siddhesh Pawar",
    avatar:
      "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
    email: "siddhesh@gmail.com",
    username: "siddhesh",
  },
  {
    name: "Richard Moon",
    avatar:
      "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
    email: "richard@gmail.com",
    username: "richard",
  },
  {
    name: "Sathvik Saya",
    avatar:
      "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
    email: "sathvik@gmail.com",
    username: "sathvik",
  },
];

export const SAMPLE_PDF =
  "https://literariness.org/wp-content/uploads/2019/06/Literariness.org-Pinter-Harold-Harold-Pinter-Plays-1-The-Birthday-Party_-The-Room_-The-Dumb-Waiter_-A-Slight-Ache_-The-Hothouse_-A-Night-Out_-Black-and-White_-Examination-1.pdf";

export const SAMPLE_ROOMS = [
  {
    videoServerId: "ap-south-1.igesia.com",
    inviteCode: "580408",
    roomName: "Marketing",
    lastMessage: {
      user: { name: "dverma", id: "PudcSa3HkXOHR6DOSpJ03XSKOh43" },
      timestamp: 1614674850707,
      content: 'dverma created room "Marketing"',
      type: 8,
      uid: "OSNRIcLtiRl7hIzbsCrK",
      createdAt: { seconds: 1614674851, nanoseconds: 85000000 },
    },
    roomStatus: 0,
    roomIdLowerCase: "7yuzsusi4l6fjguazxzj",
    roomType: 0,
    description: "",
    createdBy: "PudcSa3HkXOHR6DOSpJ03XSKOh43",
    roomPic:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Fstrategic-leadership-of-industry-4.jpg?alt=media&token=308f5ea6-a21e-43a5-bc59-a9b4d04f631d",
    createdAt: 1614674850707,
    roomId: "7YUZSusi4l6FjguAzXZJ",
  },
  {
    videoServerId: "ap-south-1.igesia.com",
    inviteCode: "095954",
    roomName: "Economics and Finance",
    lastMessage: {
      user: { name: "dverma", id: "PudcSa3HkXOHR6DOSpJ03XSKOh43" },
      timestamp: 1614674817569,
      content: 'dverma created room "Economics and Finance"',
      type: 8,
      uid: "y7X5vDwWMurWkvANmpf1",
      createdAt: { seconds: 1614674817, nanoseconds: 942000000 },
    },
    roomStatus: 0,
    roomIdLowerCase: "adob66lfyrrpt6img1sw",
    roomType: 0,
    description: "",
    createdBy: "PudcSa3HkXOHR6DOSpJ03XSKOh43",
    roomPic:
      "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/program-thumbnails%2Fexecutive-programs%2Fstrategic-leadership-of-industry-4.jpg?alt=media&token=308f5ea6-a21e-43a5-bc59-a9b4d04f631d",
    createdAt: 1614674817569,
    roomId: "Adob66lFyrRpT6Img1sw",
  },
];

export const appsAvailable = [
  {
    name: "Poll",
    route: "poll",
    type: 3,
    icon_image:
      "data:image/png;base64,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",
  },
  // {
  //   name: "Notes",
  //   route: "notes",
  //   icon_image:
  //     "data:image/png;base64,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",
  // },
  {
    name: "Quiz",
    route: "quiz",
    type: 4,
    icon_image:
      "data:image/png;base64,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",
  },
  {
    name: "Assignment",
    route: "assignment",
    type: 5,
    icon_image:
      "data:image/png;base64,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",
  },
  {
    name: "Media",
    route: "media",
    type: [6, 7, 12],
    icon_image:
      "data:image/png;base64,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",
  },
  {
    name: "Schedule",
    route: "schedule",
    type: 1,
    icon_image:
      "data:image/png;base64,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",
  },
  {
    name: "Readings",
    route: "readings",
    type: 2,
    icon_image:
      "data:image/png;base64,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",
  },
  // {
  //   name: "Gradebook",
  //   route: "gradebook",
  //   icon_image:
  //     "https://static.xx.fbcdn.net/rsrc.php/v3/yc/r/Tqo1st5w-sM.png",
  // },
  // {
  //   name: "Folder",
  //   route: "folder",
  //   icon_image:
  //     "data:image/png;base64,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",
  // },
  // {
  //   name: "Whiteboard",
  //   route: "whiteboard",
  //   icon_image:
  //     "data:image/png;base64,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",
  // },
];
